
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aME7P", function(module, exports) {

$parcel$export(module.exports, "UniformWrapper", function () { return $f1ccbec1e07eee42$export$227673ab846fab74; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $aiugz = parcelRequire("aiugz");

var $lHB9W = parcelRequire("lHB9W");

var $3A0Kj = parcelRequire("3A0Kj");

var $9Dbz6 = parcelRequire("9Dbz6");

var $2ki5H = parcelRequire("2ki5H");

var $4sbR8 = parcelRequire("4sbR8");
const $f1ccbec1e07eee42$var$resolveRenderer = ({ type: type })=>{
    const MissingComponent = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $4sbR8.UniformMissingComponent), {
            componentName: type
        });
    var _UNIFORM_DEFINITIONS_type;
    return (_UNIFORM_DEFINITIONS_type = (0, $2ki5H.default)[type]) !== null && _UNIFORM_DEFINITIONS_type !== void 0 ? _UNIFORM_DEFINITIONS_type : MissingComponent;
};
const $f1ccbec1e07eee42$export$227673ab846fab74 = ({ composition: composition, isUniformPlayground: isUniformPlayground })=>{
    const preloadedComposition = typeof window !== "undefined" ? window._uniformPreloadedComposition : null;
    const initialData = preloadedComposition || composition;
    const [data, setData] = (0, $iSvIT.useState)(initialData);
    const [isFetched, setIsFetched] = (0, $iSvIT.useState)(!!initialData);
    (0, $iSvIT.useEffect)(()=>{
        if (initialData) return;
        const fetchComposition = async ()=>{
            if (typeof window === "undefined") return;
            const { path: path, locale: locale } = (0, $9Dbz6.parseRoute)(window.location);
            const slug = path.startsWith("/") ? path.substring(1) : path;
            const cdn = "https://wac-uniform-promotion--production.us-east-1.prod.public.atl-paas.net/";
            const cdn_path = `${cdn}release/${locale}/${slug}/composition.json`;
            try {
                const req = await fetch(cdn_path);
                const file = await req.json();
                const enhancedComp = await (0, $3A0Kj.enhanceComposition)(file.compositionApiResponse.composition);
                setData(enhancedComp);
            } catch (error) {
                console.error("Error fetching composition from CDN:", error);
                if (composition) setData(composition);
            }
            setIsFetched(true);
        };
        fetchComposition();
    }, [
        initialData,
        composition
    ]);
    if (isUniformPlayground) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformPlayground), {
        resolveRenderer: $f1ccbec1e07eee42$var$resolveRenderer,
        contextualEditingEnhancer: ({ composition: composition })=>(0, $3A0Kj.enhanceComposition)(composition)
    });
    return isFetched && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformComposition), {
            data: (0, $lHB9W.expectContent)(data),
            behaviorTracking: "onLoad",
            resolveRenderer: $f1ccbec1e07eee42$var$resolveRenderer,
            contextualEditingEnhancer: ({ composition: composition })=>(0, $3A0Kj.enhanceComposition)(composition)
        })
    });
};

});
parcelRegister("2ki5H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3c70305862de902$export$2e2bcd8739ae039; });

var $g7YDa = parcelRequire("g7YDa");

var $dtOL9 = parcelRequire("dtOL9");
parcelRequire("8tetE");
var $hKdux = parcelRequire("hKdux");

var $cGo4B = parcelRequire("cGo4B");

var $65qTS = parcelRequire("65qTS");
parcelRequire("5DXmX");
var $6PX7I = parcelRequire("6PX7I");

var $1419P = parcelRequire("1419P");
parcelRequire("13r6t");
var $3DJF0 = parcelRequire("3DJF0");

var $46UAu = parcelRequire("46UAu");

var $54jXi = parcelRequire("54jXi");

var $aDgKf = parcelRequire("aDgKf");

var $7vkxP = parcelRequire("7vkxP");
parcelRequire("fNs39");
var $fgHWA = parcelRequire("fgHWA");

var $haYnf = parcelRequire("haYnf");
parcelRequire("jMHQc");
var $jiwkx = parcelRequire("jiwkx");
parcelRequire("kuzIk");
var $gGkrX = parcelRequire("gGkrX");

var $hQud5 = parcelRequire("hQud5");

var $bvk3D = parcelRequire("bvk3D");

var $dX6Xs = parcelRequire("dX6Xs");

var $JGvCj = parcelRequire("JGvCj");

var $dUTg3 = parcelRequire("dUTg3");

var $3MlHp = parcelRequire("3MlHp");
parcelRequire("lwXlz");
var $bVuUk = parcelRequire("bVuUk");

var $gMNh2 = parcelRequire("gMNh2");

var $l0zDw = parcelRequire("l0zDw");

var $19QOl = parcelRequire("19QOl");

var $lrMw1 = parcelRequire("lrMw1");

var $98ja9 = parcelRequire("98ja9");

var $hS2Tl = parcelRequire("hS2Tl");

var $7JHqD = parcelRequire("7JHqD");

var $e6r6l = parcelRequire("e6r6l");
parcelRequire("c81IA");
var $2wBma = parcelRequire("2wBma");
parcelRequire("db1CJ");
var $jnZNE = parcelRequire("jnZNE");
parcelRequire("8X3P4");
var $gnm3L = parcelRequire("gnm3L");

var $4x11f = parcelRequire("4x11f");

var $dFD1n = parcelRequire("dFD1n");

var $hykE5 = parcelRequire("hykE5");

var $ee1EE = parcelRequire("ee1EE");
parcelRequire("cmgz2");
var $y6XPA = parcelRequire("y6XPA");

var $kgmR5 = parcelRequire("kgmR5");
parcelRequire("kh16D");
var $3HmCN = parcelRequire("3HmCN");

var $liGDD = parcelRequire("liGDD");

var $ixWw7 = parcelRequire("ixWw7");

var $bMQWw = parcelRequire("bMQWw");
parcelRequire("4DwX2");
var $a35tB = parcelRequire("a35tB");

var $5TIC4 = parcelRequire("5TIC4");

var $1fx7M = parcelRequire("1fx7M");

var $9nWUO = parcelRequire("9nWUO");

var $cceBl = parcelRequire("cceBl");

var $7D1nQ = parcelRequire("7D1nQ");
parcelRequire("gcnH1");
var $4d1KE = parcelRequire("4d1KE");
parcelRequire("dj3LQ");
var $1BNhI = parcelRequire("1BNhI");
parcelRequire("borry");
var $impgo = parcelRequire("impgo");
parcelRequire("5yXyq");
var $aogEX = parcelRequire("aogEX");
parcelRequire("enK00");
var $iDXPJ = parcelRequire("iDXPJ");

var $adl56 = parcelRequire("adl56");

var $5znlu = parcelRequire("5znlu");

var $a1e48 = parcelRequire("a1e48");

var $7z1ju = parcelRequire("7z1ju");

var $adPPd = parcelRequire("adPPd");

var $2UtIB = parcelRequire("2UtIB");

var $1kxv4 = parcelRequire("1kxv4");
parcelRequire("5wZPk");
var $k6qJQ = parcelRequire("k6qJQ");

var $diZQT = parcelRequire("diZQT");

var $5hZGW = parcelRequire("5hZGW");

var $6NpvY = parcelRequire("6NpvY");

var $85qcB = parcelRequire("85qcB");

var $lOAhp = parcelRequire("lOAhp");

var $aDVDR = parcelRequire("aDVDR");

var $jzDAp = parcelRequire("jzDAp");

var $3Z0Az = parcelRequire("3Z0Az");
parcelRequire("d6DCu");
var $3gOU8 = parcelRequire("3gOU8");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e3c70305862de902$var$UNIFORM_DEFINITIONS = {
    accordion: (0, $g7YDa.default),
    agileArticleBodyContent: (0, $dtOL9.default),
    agileHubSidebarNav: (0, $hKdux.default),
    agileTutorialBodyContent: (0, $cGo4B.default),
    articleIntroductionContent: (0, $65qTS.default),
    backgroundVideoContainer: (0, $6PX7I.default),
    bannerAlert: (0, $1419P.default),
    blockContainer: (0, $hQud5.default),
    bodyContent: (0, $3DJF0.default),
    button: (0, $54jXi.default),
    card: (0, $7vkxP.default),
    collectionPricingHero: (0, $fgHWA.default),
    columnLayout: (0, $haYnf.UniformColumnLayout),
    confluenceAnimatedHero: (0, $jiwkx.default),
    connector: (0, $gGkrX.default),
    contentBlock: (0, $bvk3D.default),
    ctaWithPolygonBackground: (0, $aDgKf.default),
    customerBodyContent: (0, $46UAu.default),
    customerStat: (0, $dX6Xs.default),
    customerStoriesDetailsHero: (0, $JGvCj.default),
    customerTestimonials: (0, $dUTg3.default),
    expand: (0, $3MlHp.default),
    featuresHighlight: (0, $bVuUk.default),
    globalFooter: (0, $gMNh2.default),
    globalNav: (0, $l0zDw.default),
    heading: (0, $19QOl.default),
    heroCarousel: (0, $98ja9.default),
    heroCarouselSection: (0, $lrMw1.default),
    heroSection: (0, $hS2Tl.default),
    horizontalDivider: (0, $7JHqD.default),
    image: (0, $e6r6l.default),
    imageV2: (0, $2wBma.default),
    integration: (0, $jnZNE.default),
    invisibleContent: (0, $gnm3L.default),
    scrollableHeroCards: (0, $1BNhI.default),
    jiraTemplatesTabContentSubgridLayout: (0, $4x11f.default),
    link: (0, $dFD1n.default),
    list: (0, $hykE5.default),
    listv2: (0, $ee1EE.default),
    logos: (0, $y6XPA.default),
    lozenge: (0, $kgmR5.default),
    mobileApp: (0, $3HmCN.default),
    modal: (0, $liGDD.default),
    page: (0, $ixWw7.default),
    pagination: (0, $bMQWw.default),
    panel: (0, $a35tB.default),
    personalizationContainer: (0, $5TIC4.default),
    pricingCalculator: (0, $1fx7M.default),
    pricingTable: (0, $9nWUO.default),
    productCard: (0, $cceBl.default),
    rovoHero: (0, $4d1KE.default),
    sideNavCollection: (0, $impgo.default),
    sideNavLink: (0, $aogEX.default),
    signUpForm: (0, $iDXPJ.default),
    templateCta: (0, $k6qJQ.default),
    pullQuote: (0, $7D1nQ.default),
    singleTab: (0, $adl56.default),
    splitBackgroundContainer: (0, $5znlu.default),
    statsSection: (0, $a1e48.default),
    statsigExperimentContainer: (0, $7z1ju.default),
    statsigFeatureGateContainer: (0, $adPPd.default),
    subColumnLayout: (0, $haYnf.UniformSubColumnLayout),
    tabs12Col: (0, $2UtIB.default),
    tabs8Col: (0, $1kxv4.default),
    templateModalButton: (0, $diZQT.default),
    templatePreview: (0, $5hZGW.default),
    text: (0, $6NpvY.default),
    textWithIcon: (0, $85qcB.default),
    topicIntroductionContent: (0, $lOAhp.default),
    tutorialIntroductionContent: (0, $aDVDR.default),
    variant: (0, $jzDAp.default),
    variantContainer: (0, $3Z0Az.default),
    video: (0, $3gOU8.default)
};
var $e3c70305862de902$export$2e2bcd8739ae039 = $e3c70305862de902$var$UNIFORM_DEFINITIONS;

});
parcelRegister("dtOL9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19629cedb73f1c61$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iii3u = parcelRequire("iii3u");
const $19629cedb73f1c61$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        name: "",
        contentComponents: []
    };
    const { bodyTextContainer: bodyTextContainer } = body;
    var _bodyTextContainer_supportingConceptNameExternal, _bodyTextContainer_contentComponents;
    const formattedBody = {
        name: (_bodyTextContainer_supportingConceptNameExternal = bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : bodyTextContainer.supportingConceptNameExternal) !== null && _bodyTextContainer_supportingConceptNameExternal !== void 0 ? _bodyTextContainer_supportingConceptNameExternal : "",
        contentComponents: $19629cedb73f1c61$var$formatContentComponent((_bodyTextContainer_contentComponents = bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : bodyTextContainer.contentComponents) !== null && _bodyTextContainer_contentComponents !== void 0 ? _bodyTextContainer_contentComponents : [])
    };
    return formattedBody;
};
const $19629cedb73f1c61$var$formatContentComponent = (contentComponents)=>{
    if (!contentComponents) return [];
    const formattedContentComponents = contentComponents.map(// eslint-disable-next-line complexity
    (contentComponent)=>{
        var _contentComponent_fields, _contentComponent_fields1, _contentComponent_fields2, _contentComponent_fields3, _contentComponent_fields4, _contentComponent_fields5, _contentComponent_fields6, _contentComponent_fields7, _contentComponent_fields8, _contentComponent_fields9, _contentComponent_fields10, _contentComponent_fields11, _contentComponent_fields12, _contentComponent_fields13, _contentComponent_fields14, _contentComponent_fields15, _contentComponent_fields16, _contentComponent_fields17, _contentComponent_fields18, _contentComponent_fields19, _contentComponent_fields20, _contentComponent_fields21, _contentComponent_fields22, _contentComponent_fields23;
        if (contentComponent.sys.contentType.sys.id === "textComponent") return {
            __typename: "TextComponent",
            name: (_contentComponent_fields = contentComponent.fields) === null || _contentComponent_fields === void 0 ? void 0 : _contentComponent_fields.textComponentNameExternal,
            text: (_contentComponent_fields1 = contentComponent.fields) === null || _contentComponent_fields1 === void 0 ? void 0 : _contentComponent_fields1.text
        };
        else if (contentComponent.sys.contentType.sys.id === "assetComponent") return {
            __typename: "AssetComponent",
            asset: $19629cedb73f1c61$var$formatAsset((_contentComponent_fields2 = contentComponent.fields) === null || _contentComponent_fields2 === void 0 ? void 0 : _contentComponent_fields2.asset),
            caption: (_contentComponent_fields3 = contentComponent.fields) === null || _contentComponent_fields3 === void 0 ? void 0 : _contentComponent_fields3.assetCaption,
            assetRelatedText: (_contentComponent_fields4 = contentComponent.fields) === null || _contentComponent_fields4 === void 0 ? void 0 : _contentComponent_fields4.assetRelatedText
        };
        else if (contentComponent.sys.contentType.sys.id === "proTipComponent") {
            var _contentComponent_fields24, _contentComponent_fields25, _contentComponent_fields26, _contentComponent_fields27, _contentComponent_fields28, _contentComponent_fields29, _contentComponent_fields30;
            let proTipText = "";
            if ((_contentComponent_fields24 = contentComponent.fields) === null || _contentComponent_fields24 === void 0 ? void 0 : _contentComponent_fields24.proTipRichText) proTipText = (_contentComponent_fields25 = contentComponent.fields) === null || _contentComponent_fields25 === void 0 ? void 0 : _contentComponent_fields25.proTipRichText;
            else if ((_contentComponent_fields26 = contentComponent.fields) === null || _contentComponent_fields26 === void 0 ? void 0 : _contentComponent_fields26.proTipText) proTipText = (_contentComponent_fields27 = contentComponent.fields) === null || _contentComponent_fields27 === void 0 ? void 0 : _contentComponent_fields27.proTipText;
            else if ((_contentComponent_fields28 = contentComponent.fields) === null || _contentComponent_fields28 === void 0 ? void 0 : _contentComponent_fields28.proTipTextShort) proTipText = (_contentComponent_fields29 = contentComponent.fields) === null || _contentComponent_fields29 === void 0 ? void 0 : _contentComponent_fields29.proTipTextShort;
            return {
                __typename: "ProTipComponent",
                name: (_contentComponent_fields30 = contentComponent.fields) === null || _contentComponent_fields30 === void 0 ? void 0 : _contentComponent_fields30.proTipNameExternal,
                proTipText: proTipText
            };
        } else if (contentComponent.sys.contentType.sys.id === "embeddedVideoAsset") return {
            __typename: "EmbeddedVideoAsset",
            embeddedVideoAssetName: (_contentComponent_fields5 = contentComponent.fields) === null || _contentComponent_fields5 === void 0 ? void 0 : _contentComponent_fields5.embeddedVideoAssetNameExternal,
            embedded: (_contentComponent_fields6 = contentComponent.fields) === null || _contentComponent_fields6 === void 0 ? void 0 : _contentComponent_fields6.embedded,
            embedAssetOverlay: $19629cedb73f1c61$var$formatAsset((_contentComponent_fields7 = contentComponent.fields) === null || _contentComponent_fields7 === void 0 ? void 0 : _contentComponent_fields7.embedAssetOverlay)
        };
        else if (contentComponent.sys.contentType.sys.id === "twitterComponent") return {
            __typename: "TwitterComponent",
            twitterComponentName: (_contentComponent_fields8 = contentComponent.fields) === null || _contentComponent_fields8 === void 0 ? void 0 : _contentComponent_fields8.twitterComponentExternalName,
            tweetText: (_contentComponent_fields9 = contentComponent.fields) === null || _contentComponent_fields9 === void 0 ? void 0 : _contentComponent_fields9.tweetText,
            twitterUrl: (_contentComponent_fields10 = contentComponent.fields) === null || _contentComponent_fields10 === void 0 ? void 0 : _contentComponent_fields10.twitterUrl
        };
        else if (contentComponent.sys.contentType.sys.id === "callToAction") return {
            __typename: "CallToAction",
            title: (_contentComponent_fields11 = contentComponent.fields) === null || _contentComponent_fields11 === void 0 ? void 0 : _contentComponent_fields11.ctaTitleExternal,
            valueProposition: (_contentComponent_fields12 = contentComponent.fields) === null || _contentComponent_fields12 === void 0 ? void 0 : _contentComponent_fields12.valueProposition,
            ctaText: (_contentComponent_fields13 = contentComponent.fields) === null || _contentComponent_fields13 === void 0 ? void 0 : _contentComponent_fields13.ctaText,
            url: (_contentComponent_fields14 = contentComponent.fields) === null || _contentComponent_fields14 === void 0 ? void 0 : _contentComponent_fields14.ctaUrl,
            asset: $19629cedb73f1c61$var$formatAsset((_contentComponent_fields15 = contentComponent.fields) === null || _contentComponent_fields15 === void 0 ? void 0 : _contentComponent_fields15.ctaAsset),
            product: (_contentComponent_fields16 = contentComponent.fields) === null || _contentComponent_fields16 === void 0 ? void 0 : _contentComponent_fields16.product,
            dataBlueprintModule: (_contentComponent_fields17 = contentComponent.fields) === null || _contentComponent_fields17 === void 0 ? void 0 : _contentComponent_fields17.dataBlueprintModule
        };
        else if (contentComponent.sys.contentType.sys.id === "questionComponent") return {
            __typename: "QuestionComponent",
            questionTitle: (_contentComponent_fields18 = contentComponent.fields) === null || _contentComponent_fields18 === void 0 ? void 0 : _contentComponent_fields18.questionTitleExternal,
            answer: (_contentComponent_fields19 = contentComponent.fields) === null || _contentComponent_fields19 === void 0 ? void 0 : _contentComponent_fields19.answer,
            answerAsset: $19629cedb73f1c61$var$formatAsset((_contentComponent_fields20 = contentComponent.fields) === null || _contentComponent_fields20 === void 0 ? void 0 : _contentComponent_fields20.answerAsset)
        };
        else if (contentComponent.sys.contentType.sys.id === "callOutComponent") return {
            __typename: "CallOutComponent",
            title: (_contentComponent_fields21 = contentComponent.fields) === null || _contentComponent_fields21 === void 0 ? void 0 : _contentComponent_fields21.callOutComponentTitleExternal,
            callOutText: (_contentComponent_fields22 = contentComponent.fields) === null || _contentComponent_fields22 === void 0 ? void 0 : _contentComponent_fields22.callOutText,
            icon: $19629cedb73f1c61$var$formatAsset((_contentComponent_fields23 = contentComponent.fields) === null || _contentComponent_fields23 === void 0 ? void 0 : _contentComponent_fields23.callOutComponentIcon)
        };
        else // Default case for unknown component types
        return (0, $7Knp0._)({
            __typename: "UnknownComponent"
        }, contentComponent);
    });
    // Filter out unknown component types
    return formattedContentComponents.filter((component)=>component.__typename !== "UnknownComponent");
};
// eslint-disable-next-line complexity
const $19629cedb73f1c61$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $19629cedb73f1c61$var$UniformAgileArticleBodyContent = (props)=>{
    const bodyComponent = (0, $iSvIT.useMemo)(()=>$19629cedb73f1c61$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iii3u.AgileArticleBodyContent), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        bodyTextContainer: bodyComponent
    }));
};
var $19629cedb73f1c61$export$2e2bcd8739ae039 = $19629cedb73f1c61$var$UniformAgileArticleBodyContent;

});
parcelRegister("iii3u", function(module, exports) {

$parcel$export(module.exports, "AgileArticleBodyContent", function () { return $3be587fb1a9c4d8d$export$5ccbc19baa270323; });
/* agile-article-body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/jsx-key */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $1UUq1 = parcelRequire("1UUq1");

var $7eZEV = parcelRequire("7eZEV");

var $krNyQ = parcelRequire("krNyQ");

var $ZQ88u = parcelRequire("ZQ88u");
function $3be587fb1a9c4d8d$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
}
const $3be587fb1a9c4d8d$export$5ccbc19baa270323 = ({ bodyTextContainer: bodyTextContainer })=>{
    var _bodyTextContainer_contentComponents;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-hub-article-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthze3t"
                ]),
                children: bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : bodyTextContainer.name
            }),
            bodyTextContainer === null || bodyTextContainer === void 0 ? void 0 : (_bodyTextContainer_contentComponents = bodyTextContainer.contentComponents) === null || _bodyTextContainer_contentComponents === void 0 ? void 0 : _bodyTextContainer_contentComponents.map((component)=>{
                var _component_asset, _component_asset1, _component_asset2;
                var _component_name, _component_text, _component_asset_url, _component_asset_description, _component_asset_contentType, _component_embeddedVideoAssetName, _component_name1, _component_name2, _component_proTipText, _component_title, _component_title1, _component_callOutText, _component_questionTitle, _component_questionTitle1, _component_answer;
                if ((0, $ZQ88u.isTextComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_rrz6idpf _1cobidpf _7exwv47k _1o6vv47k"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name !== void 0 ? _component_name : "",
                        text: $3be587fb1a9c4d8d$var$getRichText((_component_text = component === null || component === void 0 ? void 0 : component.text) !== null && _component_text !== void 0 ? _component_text : "")
                    })
                });
                else if ((0, $ZQ88u.isAssetComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: (_component_asset_url = component === null || component === void 0 ? void 0 : (_component_asset = component.asset) === null || _component_asset === void 0 ? void 0 : _component_asset.url) !== null && _component_asset_url !== void 0 ? _component_asset_url : "",
                            alt: (_component_asset_description = component === null || component === void 0 ? void 0 : (_component_asset1 = component.asset) === null || _component_asset1 === void 0 ? void 0 : _component_asset1.description) !== null && _component_asset_description !== void 0 ? _component_asset_description : "",
                            contentType: (_component_asset_contentType = component === null || component === void 0 ? void 0 : (_component_asset2 = component.asset) === null || _component_asset2 === void 0 ? void 0 : _component_asset2.contentType) !== null && _component_asset_contentType !== void 0 ? _component_asset_contentType : "",
                            className: (0, $esG4f.default)([
                                "_p12f1osq"
                            ])
                        }),
                        (component === null || component === void 0 ? void 0 : component.caption) && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "fine-print"
                            ]),
                            children: component === null || component === void 0 ? void 0 : component.caption
                        })
                    ]
                });
                else if ((0, $ZQ88u.isEmbedComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                    embedLink: (component === null || component === void 0 ? void 0 : component.embedded) || "",
                    thumbnail: component === null || component === void 0 ? void 0 : component.embedAssetOverlay,
                    title: (_component_embeddedVideoAssetName = component === null || component === void 0 ? void 0 : component.embeddedVideoAssetName) !== null && _component_embeddedVideoAssetName !== void 0 ? _component_embeddedVideoAssetName : ""
                });
                else if ((0, $ZQ88u.isProTipText)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "pro-tip",
                    label: (_component_name1 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name1 !== void 0 ? _component_name1 : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name2 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name2 !== void 0 ? _component_name2 : "",
                        text: $3be587fb1a9c4d8d$var$getRichText((_component_proTipText = component === null || component === void 0 ? void 0 : component.proTipText) !== null && _component_proTipText !== void 0 ? _component_proTipText : "")
                    })
                });
                else if ((0, $ZQ88u.isCallOutComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_title = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title !== void 0 ? _component_title : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_title1 = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title1 !== void 0 ? _component_title1 : "",
                        text: $3be587fb1a9c4d8d$var$getRichText((_component_callOutText = component === null || component === void 0 ? void 0 : component.callOutText) !== null && _component_callOutText !== void 0 ? _component_callOutText : "")
                    })
                });
                else if ((0, $ZQ88u.isQuestionComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_questionTitle = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle !== void 0 ? _component_questionTitle : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_questionTitle1 = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle1 !== void 0 ? _component_questionTitle1 : "",
                        text: $3be587fb1a9c4d8d$var$getRichText((_component_answer = component === null || component === void 0 ? void 0 : component.answer) !== null && _component_answer !== void 0 ? _component_answer : "")
                    })
                });
                return null;
            })
        ]
    });
};

});


parcelRegister("8tetE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("hKdux")).default; });

var $hKdux = parcelRequire("hKdux");

});
parcelRegister("hKdux", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea5e0364749fd1f4$export$2e2bcd8739ae039; });
/* agile-hub-sidebar-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $ayjUl = parcelRequire("ayjUl");

var $2wO91 = parcelRequire("2wO91");

var $hP07d = parcelRequire("hP07d");

var $lK5pR = parcelRequire("lK5pR");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $gHHDz = parcelRequire("gHHDz");
const $ea5e0364749fd1f4$var$desktopCss = null;
const $ea5e0364749fd1f4$var$tabletMobileCss = null;
const $ea5e0364749fd1f4$var$navContainerCss = null;
const $ea5e0364749fd1f4$var$listCss = null;
const $ea5e0364749fd1f4$var$navHeaderCss = null;
const $ea5e0364749fd1f4$var$mobileExpandableButtonCss = null;
const $ea5e0364749fd1f4$var$mobileNavContentCss = null;
const $ea5e0364749fd1f4$var$mobileNavContentCollapsedCss = null;
const $ea5e0364749fd1f4$var$firstLevelNavItemCss = null;
const $ea5e0364749fd1f4$var$dividerCss = null;
const $ea5e0364749fd1f4$var$topicNameCss = null;
const $ea5e0364749fd1f4$var$topicLinkCss = null;
const $ea5e0364749fd1f4$var$topicNoNestedCss = null;
const $ea5e0364749fd1f4$var$secondLevelLinkCss = null;
const $ea5e0364749fd1f4$var$dotContainerCss = null;
const $ea5e0364749fd1f4$var$getCurrRoute = ()=>{
    let currRoute = window.location.pathname;
    if (currRoute === "/uniform-preview") {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var _urlParams_get;
        currRoute = (_urlParams_get = urlParams.get("path")) !== null && _urlParams_get !== void 0 ? _urlParams_get : "";
    }
    return currRoute;
};
const $ea5e0364749fd1f4$var$NavList = ()=>{
    const navData = (0, $gHHDz.getAgileHubSidebarNavData)();
    const localizedHref = (0, $3FBn4.useLocalizedHref);
    const getExpandedTopic = (route)=>{
        return navData.findIndex((topic)=>"nestedLinks" in topic && topic.nestedLinks.some((link)=>link.url === route));
    };
    const route = $ea5e0364749fd1f4$var$getCurrRoute();
    const expandedTopicIndex = getExpandedTopic(route);
    const lastIndex = navData.length - 1;
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        className: (0, $esG4f.default)([
            "_qtt8glyw _1yt4ze3t _18s8ze3t"
        ]),
        children: navData.map((topic, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                className: (0, $esG4f.default)([
                    "_1rjcpxbi",
                    index !== lastIndex && "_179ryzqy"
                ]),
                style: {
                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                },
                children: "url" in topic ? /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                    href: localizedHref(topic.url),
                    "aria-current": route === topic.url ? "page" : undefined,
                    className: (0, $esG4f.default)([
                        "_v564h5h4 _30l317la"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _y3gn1e5h",
                            "_bozg1f4h",
                            "h6"
                        ]),
                        children: intl.formatMessage(topic.name)
                    })
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $lK5pR.Expand), {
                    label: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: "h6",
                        children: intl.formatMessage(topic.name)
                    }),
                    isExpanded: index === expandedTopicIndex,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        id: `section-${index}`,
                        className: (0, $esG4f.default)([
                            "_qtt8glyw _1yt4ze3t _18s8ze3t"
                        ]),
                        children: topic.nestedLinks.map((link)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                                    href: localizedHref(link.url),
                                    "aria-current": route === link.url ? "page" : undefined,
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _zulpu2gc _1rjcu2gc _v564h5h4 _30l317la"
                                    ]),
                                    style: {
                                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
                                            ]),
                                            children: route === link.url && /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hP07d))), {
                                                label: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                            className: (0, $esG4f.default)([
                                                route === link.url && "_k48p1fw0",
                                                "p"
                                            ]),
                                            children: intl.formatMessage(link.name)
                                        })
                                    ]
                                })
                            }, intl.formatMessage(link.name)))
                    })
                })
            }, intl.formatMessage(topic.name)))
    });
};
const $ea5e0364749fd1f4$var$MobileExpandableNav = ({ children: children })=>{
    const intl = (0, $f6qj2.default)();
    const [isExpanded, setIsExpanded] = (0, $iSvIT.useState)(false);
    const [buttonBottom, setButtonBottom] = (0, $iSvIT.useState)(0);
    const navRef = (0, $iSvIT.useRef)(null);
    const buttonRef = (0, $iSvIT.useRef)(null);
    const contentRef = (0, $iSvIT.useRef)(null);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    }; // Calculate button position for nav positioning
    (0, $iSvIT.useEffect)(()=>{
        const updateButtonPosition = ()=>{
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setButtonBottom(rect.bottom);
            }
        };
        updateButtonPosition();
        window.addEventListener("resize", updateButtonPosition);
        window.addEventListener("scroll", updateButtonPosition);
        return ()=>{
            window.removeEventListener("resize", updateButtonPosition);
            window.removeEventListener("scroll", updateButtonPosition);
        };
    }, []); // Prevent body scroll when nav is open
    (0, $iSvIT.useEffect)(()=>{
        if (isExpanded) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
         // Cleanup on unmount
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isExpanded
    ]); // Scroll to top when nav expands
    (0, $iSvIT.useEffect)(()=>{
        if (isExpanded && contentRef.current) contentRef.current.scrollTop = 0;
    }, [
        isExpanded
    ]); // Handle click outside to close nav
    (0, $iSvIT.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (isExpanded && navRef.current && !navRef.current.contains(event.target)) setIsExpanded(false);
        };
        if (isExpanded) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: navRef,
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                ref: buttonRef,
                onClick: handleToggle,
                "aria-expanded": isExpanded,
                "aria-controls": "mobile-nav-content",
                className: (0, $esG4f.default)([
                    "_1bsb1osq _bfhk150w _19itglyw _1yt41hnt _1e0c1txw _4cvr1h6o _zulpu2gc _80omtlke _v564mfn2 _irr3u4vp _v736zwfg _chtuzwfg"
                ]),
                style: {
                    "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200")),
                    "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_4t3i1ejb _1bsb1ejb _1e0c1txw _4cvr1h6o _1bah1h6o _1wybf6fq _k48p8n31 _syaz17la"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                        },
                        children: isExpanded ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2wO91))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ayjUl))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: "eyebrow-md",
                        children: intl.formatMessage({
                            id: "agile-hub.sidenav.agile-hub-topics",
                            defaultMessage: "Agile hub topics"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: contentRef,
                id: "mobile-nav-content",
                className: (0, $esG4f.default)([
                    "_bfhkcd5j _1bsb1osq _bozg1wqb _y4ti1wqb _v5641pfq _1reo1wug _18m91wug _v736zwfg _chtuzwfg",
                    isExpanded ? "_kqsw1n9t _152t1um1 _1e02idpf _rjxpidpf _u7coidpf _1bsbauwl _4t3iqi8f _c71lqi8f _tzy4kb7n _1pbyzo7u _1reo15vq _18m915vq _bfhkcd5j _1q51v47k _85i51ejb _bozg1wqb _y4ti1wqb _v736xy5q _chtuxy5q" : "_c71lidpf _tzy4idpf"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                    "--_ab93rs": (0, $43MIc.default)(buttonBottom, "px")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3i1osq _1reo1wug _18m91wug _85i51ejb"
                    ]),
                    children: children
                })
            })
        ]
    });
};
const $ea5e0364749fd1f4$var$UniformAgileHubSidebarNav = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "aria-label": "Sidebar Navigation",
        className: (0, $esG4f.default)([
            "_19ityzqy _2rkovwyg _1yt4v47k _tnv2150w _tl28idpf _axwiidpf _1hwcidpf _sp8tidpf _13jeglyw _1l9uidpf"
        ]),
        style: {
            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
            "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1mjbglyw",
                    "tablet-desktop-nav"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _1yt41dg4",
                            "eyebrow-md"
                        ]),
                        children: intl.formatMessage({
                            id: "agile-hub.sidenav.browse-topics",
                            defaultMessage: "Browse topics"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_c71l1pse _1reo1wug _18m91wug"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($ea5e0364749fd1f4$var$NavList, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_dm25glyw _kqsw1n9t _1pbykb7n _1bsb1osq",
                    "mobile-nav"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($ea5e0364749fd1f4$var$MobileExpandableNav, {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($ea5e0364749fd1f4$var$NavList, {})
                })
            })
        ]
    });
};
var $ea5e0364749fd1f4$export$2e2bcd8739ae039 = $ea5e0364749fd1f4$var$UniformAgileHubSidebarNav;

});
parcelRegister("2wO91", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d75779a6f475134$var$_react = $1d75779a6f475134$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1d75779a6f475134$var$_baseNew = $1d75779a6f475134$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $1d75779a6f475134$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d75779a6f475134$var$MinusIcon = (props)=>/*#__PURE__*/ $1d75779a6f475134$var$_react.default.createElement($1d75779a6f475134$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$1d75779a6f475134$var$MinusIcon.displayName = "MinusIcon";
var $1d75779a6f475134$var$_default = module.exports.default = $1d75779a6f475134$var$MinusIcon;

});

parcelRegister("gHHDz", function(module, exports) {

$parcel$export(module.exports, "getAgileHubSidebarNavData", function () { return $80cb4bf9ad6af9e6$export$8fb0a717eaa8070d; });

var $6x1qA = parcelRequire("6x1qA");
const $80cb4bf9ad6af9e6$export$8fb0a717eaa8070d = ()=>{
    return [
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.agile-coach",
                defaultMessage: "The Agile Coach"
            }),
            url: "/agile"
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.agile-manifesto",
                defaultMessage: "Agile Manifesto"
            }),
            url: "/agile/manifesto"
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.scrum",
                defaultMessage: "Scrum"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.sprints",
                        defaultMessage: "Sprints"
                    }),
                    url: "/agile/scrum/sprints"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.sprint-planning",
                        defaultMessage: "Sprint planning"
                    }),
                    url: "/agile/scrum/sprint-planning"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.ceremonies",
                        defaultMessage: "Ceremonies"
                    }),
                    url: "/agile/scrum/ceremonies"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.backlogs",
                        defaultMessage: "Backlogs"
                    }),
                    url: "/agile/scrum/backlogs"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.sprint-reviews",
                        defaultMessage: "Sprint reviews"
                    }),
                    url: "/agile/scrum/sprint-reviews"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.standups",
                        defaultMessage: "Standups"
                    }),
                    url: "/agile/scrum/standups"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-master",
                        defaultMessage: "Scrum master"
                    }),
                    url: "/agile/scrum/scrum-master"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.retrospectives",
                        defaultMessage: "Retrospectives"
                    }),
                    url: "/agile/scrum/retrospectives"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.distributed-scrum",
                        defaultMessage: "Distributed scrum"
                    }),
                    url: "/agile/scrum/distributed-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.roles",
                        defaultMessage: "Roles"
                    }),
                    url: "/agile/scrum/roles"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-of-scrums",
                        defaultMessage: "Scrum of scrums"
                    }),
                    url: "/agile/scrum/scrum-of-scrums"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.artifacts",
                        defaultMessage: "Agile scrum artifacts"
                    }),
                    url: "/agile/scrum/artifacts"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-metrics",
                        defaultMessage: "Scrum metrics"
                    }),
                    url: "/agile/scrum/scrum-metrics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.jira-confluence-scrum",
                        defaultMessage: "Jira Confluence scrum"
                    }),
                    url: "/agile/scrum/jira-confluence-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.agile-vs-scrum",
                        defaultMessage: "Agile vs Scrum"
                    }),
                    url: "/agile/scrum/agile-vs-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.backlog-refinement",
                        defaultMessage: "Backlog Refinement Guide"
                    }),
                    url: "/agile/scrum/backlog-refinement"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.scrum.scrum-master-project-manager",
                        defaultMessage: "Scrum master vs. project manager"
                    }),
                    url: "/agile/scrum/scrum-master-project-manager"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.kanban",
                defaultMessage: "Kanban"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/kanban"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban.boards",
                        defaultMessage: "Boards"
                    }),
                    url: "/agile/kanban/boards"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban.wip-limits",
                        defaultMessage: "WIP limits"
                    }),
                    url: "/agile/kanban/wip-limits"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban.kanban-vs-scrum",
                        defaultMessage: "Kanban vs Scrum"
                    }),
                    url: "/agile/kanban/kanban-vs-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban.kanplan",
                        defaultMessage: "Kanplan"
                    }),
                    url: "/agile/kanban/kanplan"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.kanban.cards",
                        defaultMessage: "Kanban cards"
                    }),
                    url: "/agile/kanban/cards"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.project-management",
                defaultMessage: "Agile project management"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/project-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-management-intro",
                        defaultMessage: "Project management intro"
                    }),
                    url: "/agile/project-management/project-management-intro"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow",
                        defaultMessage: "Workflow"
                    }),
                    url: "/agile/project-management/workflow"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.epics-stories-themes",
                        defaultMessage: "Epics, stories, themes"
                    }),
                    url: "/agile/project-management/epics-stories-themes"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.epics",
                        defaultMessage: "Epics"
                    }),
                    url: "/agile/project-management/epics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.user-stories",
                        defaultMessage: "User Stories"
                    }),
                    url: "/agile/project-management/user-stories"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.estimation",
                        defaultMessage: "Estimation"
                    }),
                    url: "/agile/project-management/estimation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.metrics",
                        defaultMessage: "Metrics"
                    }),
                    url: "/agile/project-management/metrics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.gantt-chart",
                        defaultMessage: "Gantt chart"
                    }),
                    url: "/agile/project-management/gantt-chart"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.program-management",
                        defaultMessage: "Program management vs. project management"
                    }),
                    url: "/agile/project-management/program-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-baseline",
                        defaultMessage: "Project baseline"
                    }),
                    url: "/agile/project-management/project-baseline"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.continuous-improvement",
                        defaultMessage: "Continuous improvement"
                    }),
                    url: "/agile/project-management/continuous-improvement"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-principles",
                        defaultMessage: "Lean principles"
                    }),
                    url: "/agile/project-management/lean-principles"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.3-pillars-scrum",
                        defaultMessage: "3 pillars of Scrum"
                    }),
                    url: "/agile/project-management/3-pillars-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrum-board",
                        defaultMessage: "Scrum Board"
                    }),
                    url: "/agile/project-management/scrum-board"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.waterfall-methodology",
                        defaultMessage: "Waterfall Methodology"
                    }),
                    url: "/agile/project-management/waterfall-methodology"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.velocity-scrum",
                        defaultMessage: "Velocity in Scrum"
                    }),
                    url: "/agile/project-management/velocity-scrum"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.definition-of-ready",
                        defaultMessage: "What is Definition of Ready"
                    }),
                    url: "/agile/project-management/definition-of-ready"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-vs-agile",
                        defaultMessage: "Lean vs. agile"
                    }),
                    url: "/agile/project-management/lean-vs-agile"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrumban",
                        defaultMessage: "Scrumban"
                    }),
                    url: "/agile/project-management/scrumban"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-methodology",
                        defaultMessage: "Lean Methodology"
                    }),
                    url: "/agile/project-management/lean-methodology"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-backlog",
                        defaultMessage: "Sprint backlog"
                    }),
                    url: "/agile/project-management/sprint-backlog"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.burn-up-chart",
                        defaultMessage: "Burn up chart"
                    }),
                    url: "/agile/project-management/burn-up-chart"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.kanban-principles",
                        defaultMessage: "4 kanban principles"
                    }),
                    url: "/agile/project-management/kanban-principles"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.kanban-metrics",
                        defaultMessage: "4 kanban metrics"
                    }),
                    url: "/agile/project-management/kanban-metrics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.program-vs-project-manager",
                        defaultMessage: "Program vs. Project Manager"
                    }),
                    url: "/agile/project-management/program-vs-project-manager"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.gantt-chart-examples",
                        defaultMessage: "Gantt chart examples"
                    }),
                    url: "/agile/project-management/gantt-chart-examples"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.definition-of-done",
                        defaultMessage: "Definition of done"
                    }),
                    url: "/agile/project-management/definition-of-done"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.backlog-grooming",
                        defaultMessage: "Backlog grooming"
                    }),
                    url: "/agile/project-management/backlog-grooming"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.lean-process-improvement",
                        defaultMessage: "Lean process improvement"
                    }),
                    url: "/agile/project-management/lean-process-improvement"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.backlog-refinement-meeting",
                        defaultMessage: "Backlog refinement meetings"
                    }),
                    url: "/agile/project-management/backlog-refinement-meeting"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrum-values",
                        defaultMessage: "Scrum values"
                    }),
                    url: "/agile/project-management/scrum-values"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scope-of-work",
                        defaultMessage: "Scope of work"
                    }),
                    url: "/agile/project-management/scope-of-work"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.scrum-tools",
                        defaultMessage: "Scrum tools"
                    }),
                    url: "/agile/project-management/scrum-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.tools",
                        defaultMessage: "Tools"
                    }),
                    url: "/agile/project-management/tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-automation-software",
                        defaultMessage: "Workflow automation software"
                    }),
                    url: "/agile/project-management/workflow-automation-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.templates",
                        defaultMessage: "Templates"
                    }),
                    url: "/agile/project-management/templates"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-tracker",
                        defaultMessage: "Task tracker"
                    }),
                    url: "/agile/project-management/task-tracker"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-automation",
                        defaultMessage: "Workflow automation"
                    }),
                    url: "/agile/project-management/workflow-automation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.status-report",
                        defaultMessage: "Status report"
                    }),
                    url: "/agile/project-management/status-report"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-chart",
                        defaultMessage: "Workflow chart"
                    }),
                    url: "/agile/project-management/workflow-chart"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-roadmap",
                        defaultMessage: "Project roadmap"
                    }),
                    url: "/agile/project-management/project-roadmap"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-schedule",
                        defaultMessage: "Project schedule"
                    }),
                    url: "/agile/project-management/project-schedule"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.issue-tracking-software",
                        defaultMessage: "Tracking software"
                    }),
                    url: "/agile/project-management/issue-tracking-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.roadmap-tools",
                        defaultMessage: "Roadmap tools"
                    }),
                    url: "/agile/project-management/roadmap-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.technology-roadmap",
                        defaultMessage: "Technology roadmap"
                    }),
                    url: "/agile/project-management/technology-roadmap"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-scheduling-software",
                        defaultMessage: "Project scheduling software"
                    }),
                    url: "/agile/project-management/project-scheduling-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.backlog-management-tools",
                        defaultMessage: "Backlog management tools"
                    }),
                    url: "/agile/project-management/backlog-management-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-management",
                        defaultMessage: "Understanding workflow management strategies"
                    }),
                    url: "/agile/project-management/workflow-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-examples",
                        defaultMessage: "Workflow examples"
                    }),
                    url: "/agile/project-management/workflow-examples"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.create-project-roadmap",
                        defaultMessage: "Create project roadmap"
                    }),
                    url: "/agile/project-management/create-project-roadmap"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-planning-tools",
                        defaultMessage: "Sprint planning tools"
                    }),
                    url: "/agile/project-management/sprint-planning-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-demo",
                        defaultMessage: "Sprint demo"
                    }),
                    url: "/agile/project-management/sprint-demo"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-timeline-software",
                        defaultMessage: "Project Timeline Software"
                    }),
                    url: "/agile/project-management/project-timeline-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-management-tools",
                        defaultMessage: "Top task management tools"
                    }),
                    url: "/agile/project-management/task-management-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-backlog-product-backlog",
                        defaultMessage: "Product backlog vs. sprint backlog"
                    }),
                    url: "/agile/project-management/sprint-backlog-product-backlog"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.workflow-management-tools",
                        defaultMessage: "Top workflow management tools"
                    }),
                    url: "/agile/project-management/workflow-management-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.project-management-dependencies",
                        defaultMessage: "Project dependencies"
                    }),
                    url: "/agile/project-management/project-management-dependencies"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.task-management-dashboard",
                        defaultMessage: "Task dashboard guide"
                    }),
                    url: "/agile/project-management/task-management-dashboard"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.sprint-cadence",
                        defaultMessage: "Sprint cadence"
                    }),
                    url: "/agile/project-management/sprint-cadence"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.fast-tracking",
                        defaultMessage: "Fast tracking"
                    }),
                    url: "/agile/project-management/fast-tracking"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.fibonacci-story-points",
                        defaultMessage: "Fibonacci story points"
                    }),
                    url: "/agile/project-management/fibonacci-story-points"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.product-vs-project-management",
                        defaultMessage: "Product vs. Project Management"
                    }),
                    url: "/agile/project-management/product-vs-project-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.deadline-management",
                        defaultMessage: "Deadline management"
                    }),
                    url: "/agile/project-management/deadline-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.project-management.skills",
                        defaultMessage: "10 must-have skills"
                    }),
                    url: "/agile/project-management/skills"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.product-management",
                defaultMessage: "Product Management"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/product-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-roadmaps",
                        defaultMessage: "Product Roadmaps"
                    }),
                    url: "/agile/product-management/product-roadmaps"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-manager",
                        defaultMessage: "Product Manager"
                    }),
                    url: "/agile/product-management/product-manager"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.tips-for-new-product-manager",
                        defaultMessage: "Tips for new product managers"
                    }),
                    url: "/agile/product-management/tips-for-new-product-manager"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.roadmaps",
                        defaultMessage: "Roadmaps"
                    }),
                    url: "/agile/product-management/roadmaps"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.tips-for-presenting-product-roadmaps",
                        defaultMessage: "Tips for presenting product roadmaps"
                    }),
                    url: "/agile/product-management/tips-for-presenting-product-roadmaps"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.requirements",
                        defaultMessage: "Requirements"
                    }),
                    url: "/agile/product-management/requirements"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-analytics",
                        defaultMessage: "Product analytics"
                    }),
                    url: "/agile/product-management/product-analytics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-development",
                        defaultMessage: "Product development"
                    }),
                    url: "/agile/product-management/product-development"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.remote-product-management",
                        defaultMessage: "Remote product management"
                    }),
                    url: "/agile/product-management/remote-product-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.minimum-viable-product",
                        defaultMessage: "Minimal viable product"
                    }),
                    url: "/agile/product-management/minimum-viable-product"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.discovery",
                        defaultMessage: "Product discovery"
                    }),
                    url: "/agile/product-management/discovery"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-specification",
                        defaultMessage: "Product specification"
                    }),
                    url: "/agile/product-management/product-specification"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-development-strategy",
                        defaultMessage: "Product development strategy"
                    }),
                    url: "/agile/product-management/product-development-strategy"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-development-software",
                        defaultMessage: "Product development software"
                    }),
                    url: "/agile/product-management/product-development-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.new-product-development-process",
                        defaultMessage: "New product development process"
                    }),
                    url: "/agile/product-management/new-product-development-process"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-management-kpis",
                        defaultMessage: "Product management KPIs"
                    }),
                    url: "/agile/product-management/product-management-kpis"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.nps-score",
                        defaultMessage: "Net Promoter Score (NPS)"
                    }),
                    url: "/agile/product-management/nps-score"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-critique",
                        defaultMessage: "Product critique"
                    }),
                    url: "/agile/product-management/product-critique"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.prioritization-framework",
                        defaultMessage: "Prioritization frameworks"
                    }),
                    url: "/agile/product-management/prioritization-framework"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-features",
                        defaultMessage: "Product features"
                    }),
                    url: "/agile/product-management/product-features"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-management-tools",
                        defaultMessage: "Product management tools"
                    }),
                    url: "/agile/product-management/product-management-tools"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.plm",
                        defaultMessage: "Product Lifecycle Management"
                    }),
                    url: "/agile/product-management/plm"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.roadmap-software",
                        defaultMessage: "9 best roadmap software for teams"
                    }),
                    url: "/agile/product-management/roadmap-software"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-launch-checklist",
                        defaultMessage: "Product launch checklist"
                    }),
                    url: "/agile/product-management/product-launch-checklist"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-strategy",
                        defaultMessage: "Product strategy"
                    }),
                    url: "/agile/product-management/product-strategy"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-engineering",
                        defaultMessage: "Product engineering"
                    }),
                    url: "/agile/product-management/product-engineering"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-operations",
                        defaultMessage: "Product operations"
                    }),
                    url: "/agile/product-management/product-operations"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.portfolio-management",
                        defaultMessage: "Portfolio management"
                    }),
                    url: "/agile/product-management/portfolio-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.pm-and-ai",
                        defaultMessage: "AI and product management"
                    }),
                    url: "/agile/product-management/pm-and-ai"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.growth-product-management",
                        defaultMessage: "Growth product management"
                    }),
                    url: "/agile/product-management/growth-product-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-metrics",
                        defaultMessage: "Product metrics"
                    }),
                    url: "/agile/product-management/product-metrics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-release",
                        defaultMessage: "Product release"
                    }),
                    url: "/agile/product-management/product-release"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.feature-request",
                        defaultMessage: "Feature request"
                    }),
                    url: "/agile/product-management/feature-request"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-launch",
                        defaultMessage: "Product launch"
                    }),
                    url: "/agile/product-management/product-launch"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-planning",
                        defaultMessage: "Product planning"
                    }),
                    url: "/agile/product-management/product-planning"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-launch-event",
                        defaultMessage: "Product launch event"
                    }),
                    url: "/agile/product-management/product-launch-event"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-operating-model",
                        defaultMessage: "Product operating model"
                    }),
                    url: "/agile/product-management/product-operating-model"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.product-management.product-design",
                        defaultMessage: "Product design"
                    }),
                    url: "/agile/product-management/product-design"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.value-stream-management",
                defaultMessage: "Value Stream Management"
            }),
            url: "/agile/value-stream-management"
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.advantage",
                defaultMessage: "The agile advantage"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.advantage-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/advantage"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.advantage.connect-business-strategy-to-development-reality",
                        defaultMessage: "Connecting business strategy to development reality"
                    }),
                    url: "/agile/advantage/connect-business-strategy-to-development-reality"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.advantage.agile-is-a-competitive-advantage",
                        defaultMessage: "Agile is a competitive advantage"
                    }),
                    url: "/agile/advantage/agile-is-a-competitive-advantage"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.advantage.agile-mindset",
                        defaultMessage: "Cultivating an agile mindset"
                    }),
                    url: "/agile/advantage/agile-mindset"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.advantage.going-agile",
                        defaultMessage: "Going agile"
                    }),
                    url: "/agile/advantage/going-agile"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.agile-at-scale",
                defaultMessage: "Agile at scale"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/agile-at-scale"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.managing-an-agile-portfolio",
                        defaultMessage: "Managing an agile portfolio"
                    }),
                    url: "/agile/agile-at-scale/managing-an-agile-portfolio"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.lean-portfolio-management",
                        defaultMessage: "Lean portfolio management"
                    }),
                    url: "/agile/agile-at-scale/lean-portfolio-management"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.okr",
                        defaultMessage: "Okrs"
                    }),
                    url: "/agile/agile-at-scale/okr"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.long-term-agile-planning",
                        defaultMessage: "Long-term agile planning"
                    }),
                    url: "/agile/agile-at-scale/long-term-agile-planning"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.what-is-safe",
                        defaultMessage: "What is SAFe?"
                    }),
                    url: "/agile/agile-at-scale/what-is-safe"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.spotify",
                        defaultMessage: "Spotify model"
                    }),
                    url: "/agile/agile-at-scale/spotify"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.scrum-at-scale",
                        defaultMessage: "Organizational agility with Scrum@Scale"
                    }),
                    url: "/agile/agile-at-scale/scrum-at-scale"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.agile-iron-triangle",
                        defaultMessage: "Agile iron triangle"
                    }),
                    url: "/agile/agile-at-scale/agile-iron-triangle"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.less",
                        defaultMessage: "The Large-Scale Scrum (LeSS) framework"
                    }),
                    url: "/agile/agile-at-scale/less"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.using-improvement-kata-to-support-lean",
                        defaultMessage: "Using Improvement Kata to support lean"
                    }),
                    url: "/agile/agile-at-scale/using-improvement-kata-to-support-lean"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-at-scale.beyond-the-basics-whitepaper",
                        defaultMessage: "Beyond the basics whitepaper"
                    }),
                    url: "/agile/agile-at-scale/beyond-the-basics-whitepaper"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.software-development",
                defaultMessage: "Software development"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/software-development"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.developer",
                        defaultMessage: "Developer"
                    }),
                    url: "/agile/software-development/developer"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.dev-managers-vs-scrum-masters",
                        defaultMessage: "Dev managers vs scrum masters"
                    }),
                    url: "/agile/software-development/dev-managers-vs-scrum-masters"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.git",
                        defaultMessage: "Git"
                    }),
                    url: "/agile/software-development/git"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.branching",
                        defaultMessage: "Branching"
                    }),
                    url: "/agile/software-development/branching"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.git-branching-video",
                        defaultMessage: "Git branching video"
                    }),
                    url: "/agile/software-development/git-branching-video"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.code-reviews",
                        defaultMessage: "Code reviews"
                    }),
                    url: "/agile/software-development/code-reviews"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.release",
                        defaultMessage: "Release"
                    }),
                    url: "/agile/software-development/release"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.technical-debt",
                        defaultMessage: "Technical debt"
                    }),
                    url: "/agile/software-development/technical-debt"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.testing",
                        defaultMessage: "Testing"
                    }),
                    url: "/agile/software-development/testing"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.incident-response",
                        defaultMessage: "Incident response"
                    }),
                    url: "/agile/software-development/incident-response"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.continuous-integration",
                        defaultMessage: "Continuous integration"
                    }),
                    url: "/agile/software-development/continuous-integration"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.sdlc",
                        defaultMessage: "Sdlc"
                    }),
                    url: "/agile/software-development/sdlc"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.bug-triage",
                        defaultMessage: "Bug triage: definition, examples, and best practices"
                    }),
                    url: "/agile/software-development/bug-triage"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.software-development.software-deployment",
                        defaultMessage: "Software deployment"
                    }),
                    url: "/agile/software-development/software-deployment"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.design",
                defaultMessage: "Design"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.design-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/design"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.design.product-design-process-customer-interview",
                        defaultMessage: "Product design process customer interview"
                    }),
                    url: "/agile/design/product-design-process-customer-interview"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.design.collaborative-design-in-agile-teams-video",
                        defaultMessage: "Collaborative design in agile teams video"
                    }),
                    url: "/agile/design/collaborative-design-in-agile-teams-video"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.agile-marketing",
                defaultMessage: "Agile marketing"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/agile-marketing"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.what-is-agile-marketing",
                        defaultMessage: "What is Agile Marketing?"
                    }),
                    url: "/agile/agile-marketing/what-is-agile-marketing"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.agile-marketing-team",
                        defaultMessage: "How to create an agile marketing team"
                    }),
                    url: "/agile/agile-marketing/agile-marketing-team"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-marketing.ai-marketing-automation",
                        defaultMessage: "AI marketing automation"
                    }),
                    url: "/agile/agile-marketing/ai-marketing-automation"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.devops",
                defaultMessage: "DevOps"
            }),
            url: "/agile/devops"
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.teams",
                defaultMessage: "Agile Teams"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/teams"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.remote-teams",
                        defaultMessage: "Remote teams"
                    }),
                    url: "/agile/teams/remote-teams"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.working-with-specialists",
                        defaultMessage: "Working with specialists"
                    }),
                    url: "/agile/teams/working-with-specialists"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.release-ready-teams",
                        defaultMessage: "Release ready teams"
                    }),
                    url: "/agile/teams/release-ready-teams"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.agilents-agile-transformation-journey",
                        defaultMessage: "Agilent's agile transformation journey"
                    }),
                    url: "/agile/teams/agilents-agile-transformation-journey"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.advanced-roadmaps-teams",
                        defaultMessage: "Advanced Roadmaps"
                    }),
                    url: "/agile/teams/advanced-roadmaps-teams"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.jira-twitter-unified-projects-teamwork",
                        defaultMessage: "How Twitter uses Jira"
                    }),
                    url: "/agile/teams/jira-twitter-unified-projects-teamwork"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.teams.scrum-kanban-agile",
                        defaultMessage: "How we chose our agile"
                    }),
                    url: "/agile/teams/scrum-kanban-agile"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.tutorials",
                defaultMessage: "Agile tutorials"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/tutorials"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.jira-confluence-sprint-refinement",
                        defaultMessage: "Jira and Confluence sprint refinement"
                    }),
                    url: "/agile/tutorials/jira-confluence-sprint-refinement"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-do-scrum-with-jira-software",
                        defaultMessage: "How to do scrum with Jira"
                    }),
                    url: "/agile/tutorials/how-to-do-scrum-with-jira"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-do-kanban-with-jira-software",
                        defaultMessage: "Learn kanban with Jira"
                    }),
                    url: "/agile/tutorials/how-to-do-kanban-with-jira"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.epics",
                        defaultMessage: "Learn how to use Epics in Jira"
                    }),
                    url: "/agile/tutorials/epics"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.creating-your-agile-board",
                        defaultMessage: "Learn how to create an agile board in Jira"
                    }),
                    url: "/agile/tutorials/creating-your-agile-board"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.sprints",
                        defaultMessage: "Learn how to use sprints in Jira"
                    }),
                    url: "/agile/tutorials/sprints"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.versions",
                        defaultMessage: "Learn Versions with Jira"
                    }),
                    url: "/agile/tutorials/versions"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.issues",
                        defaultMessage: "Learn Issues with Jira"
                    }),
                    url: "/agile/tutorials/issues"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.burndown-charts",
                        defaultMessage: "Learn burndown charts with Jira"
                    }),
                    url: "/agile/tutorials/burndown-charts"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-auto-create-subtasks-with-jira-software-automation",
                        defaultMessage: "Auto-create sub-tasks and update fields in Jira"
                    }),
                    url: "/agile/tutorials/how-to-auto-create-subtasks-with-jira-automation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-automatically-assign-issues-with-jira-software-automation",
                        defaultMessage: "How to automatically assign issues with Jira Automation"
                    }),
                    url: "/agile/tutorials/how-to-automatically-assign-issues-with-jira-software-automation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-sync-epics-stories-with-jira-software-automation",
                        defaultMessage: "How to sync epics stories with Jira Automation"
                    }),
                    url: "/agile/tutorials/how-to-sync-epics-stories-with-jira-software-automation"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.tutorials.how-to-escalate-overdue-issues-with-jira-software-automation",
                        defaultMessage: "Automatically escalate overdue issues in Jira"
                    }),
                    url: "/agile/tutorials/how-to-escalate-overdue-issues-with-jira-software-automation"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.agile-conversations",
                defaultMessage: "Agile conversations"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/agile-conversations"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations.marketing-agility",
                        defaultMessage: "Unlocking marketing agility"
                    }),
                    url: "/agile/agile-conversations/marketing-agility"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations.customer-research-tips",
                        defaultMessage: "The power of agile and customer insights"
                    }),
                    url: "/agile/agile-conversations/customer-research-tips"
                },
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.agile-conversations.think-big-work-small",
                        defaultMessage: "Think big, work small"
                    }),
                    url: "/agile/agile-conversations/think-big-work-small"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.about",
                defaultMessage: "About the Agile Coach"
            }),
            nestedLinks: [
                {
                    name: (0, $6x1qA.defineMessage)({
                        id: "agile-hub.sidenav.about-overview",
                        defaultMessage: "Overview"
                    }),
                    url: "/agile/about"
                }
            ]
        },
        {
            name: (0, $6x1qA.defineMessage)({
                id: "agile-hub.sidenav.all-articles",
                defaultMessage: "All articles"
            }),
            url: "/agile/articles"
        }
    ];
};

});



parcelRegister("cGo4B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $600c8041298aec96$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $6z0RS = parcelRequire("6z0RS");
const $600c8041298aec96$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        tutorialUseStepTitle: null,
        tutorialBodyTextContainer: null
    };
    const { tutorialInstructionSteps: tutorialInstructionSteps } = body;
    var _tutorialInstructionSteps_tutorialUseStepTitleExternal, _formatContentComponent;
    const formattedBody = {
        tutorialUseStepTitle: (_tutorialInstructionSteps_tutorialUseStepTitleExternal = tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : tutorialInstructionSteps.tutorialUseStepTitleExternal) !== null && _tutorialInstructionSteps_tutorialUseStepTitleExternal !== void 0 ? _tutorialInstructionSteps_tutorialUseStepTitleExternal : null,
        tutorialBodyTextContainer: (_formatContentComponent = $600c8041298aec96$var$formatContentComponent(tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : tutorialInstructionSteps.tutorialBodyTextContainer)) !== null && _formatContentComponent !== void 0 ? _formatContentComponent : null
    };
    return formattedBody;
};
const $600c8041298aec96$var$formatContentComponent = (contentComponents)=>{
    if (!contentComponents) return [];
    const formattedContentComponents = contentComponents.map(// eslint-disable-next-line complexity
    (contentComponent)=>{
        var _contentComponent_fields, _contentComponent_fields1, _contentComponent_fields2, _contentComponent_fields3, _contentComponent_fields4, _contentComponent_fields5, _contentComponent_fields6, _contentComponent_fields7, _contentComponent_fields8, _contentComponent_fields9, _contentComponent_fields10, _contentComponent_fields11, _contentComponent_fields12, _contentComponent_fields13, _contentComponent_fields14, _contentComponent_fields15, _contentComponent_fields16, _contentComponent_fields17, _contentComponent_fields18, _contentComponent_fields19, _contentComponent_fields20, _contentComponent_fields21, _contentComponent_fields22, _contentComponent_fields23;
        if (contentComponent.sys.contentType.sys.id === "textComponent") return {
            __typename: "TextComponent",
            name: (_contentComponent_fields = contentComponent.fields) === null || _contentComponent_fields === void 0 ? void 0 : _contentComponent_fields.textComponentNameExternal,
            text: (_contentComponent_fields1 = contentComponent.fields) === null || _contentComponent_fields1 === void 0 ? void 0 : _contentComponent_fields1.text
        };
        else if (contentComponent.sys.contentType.sys.id === "assetComponent") return {
            __typename: "AssetComponent",
            asset: $600c8041298aec96$var$formatAsset((_contentComponent_fields2 = contentComponent.fields) === null || _contentComponent_fields2 === void 0 ? void 0 : _contentComponent_fields2.asset),
            caption: (_contentComponent_fields3 = contentComponent.fields) === null || _contentComponent_fields3 === void 0 ? void 0 : _contentComponent_fields3.assetCaption,
            assetRelatedText: (_contentComponent_fields4 = contentComponent.fields) === null || _contentComponent_fields4 === void 0 ? void 0 : _contentComponent_fields4.assetRelatedText
        };
        else if (contentComponent.sys.contentType.sys.id === "proTipComponent") {
            var _contentComponent_fields24, _contentComponent_fields25, _contentComponent_fields26, _contentComponent_fields27, _contentComponent_fields28, _contentComponent_fields29, _contentComponent_fields30;
            let proTipText = "";
            if ((_contentComponent_fields24 = contentComponent.fields) === null || _contentComponent_fields24 === void 0 ? void 0 : _contentComponent_fields24.proTipRichText) proTipText = (_contentComponent_fields25 = contentComponent.fields) === null || _contentComponent_fields25 === void 0 ? void 0 : _contentComponent_fields25.proTipRichText;
            else if ((_contentComponent_fields26 = contentComponent.fields) === null || _contentComponent_fields26 === void 0 ? void 0 : _contentComponent_fields26.proTipText) proTipText = (_contentComponent_fields27 = contentComponent.fields) === null || _contentComponent_fields27 === void 0 ? void 0 : _contentComponent_fields27.proTipText;
            else if ((_contentComponent_fields28 = contentComponent.fields) === null || _contentComponent_fields28 === void 0 ? void 0 : _contentComponent_fields28.proTipTextShort) proTipText = (_contentComponent_fields29 = contentComponent.fields) === null || _contentComponent_fields29 === void 0 ? void 0 : _contentComponent_fields29.proTipTextShort;
            return {
                __typename: "ProTipComponent",
                name: (_contentComponent_fields30 = contentComponent.fields) === null || _contentComponent_fields30 === void 0 ? void 0 : _contentComponent_fields30.proTipNameExternal,
                proTipText: proTipText
            };
        } else if (contentComponent.sys.contentType.sys.id === "embeddedVideoAsset") return {
            __typename: "EmbeddedVideoAsset",
            embeddedVideoAssetName: (_contentComponent_fields5 = contentComponent.fields) === null || _contentComponent_fields5 === void 0 ? void 0 : _contentComponent_fields5.embeddedVideoAssetNameExternal,
            embedded: (_contentComponent_fields6 = contentComponent.fields) === null || _contentComponent_fields6 === void 0 ? void 0 : _contentComponent_fields6.embedded,
            embedAssetOverlay: $600c8041298aec96$var$formatAsset((_contentComponent_fields7 = contentComponent.fields) === null || _contentComponent_fields7 === void 0 ? void 0 : _contentComponent_fields7.embedAssetOverlay)
        };
        else if (contentComponent.sys.contentType.sys.id === "twitterComponent") return {
            __typename: "TwitterComponent",
            twitterComponentName: (_contentComponent_fields8 = contentComponent.fields) === null || _contentComponent_fields8 === void 0 ? void 0 : _contentComponent_fields8.twitterComponentExternalName,
            tweetText: (_contentComponent_fields9 = contentComponent.fields) === null || _contentComponent_fields9 === void 0 ? void 0 : _contentComponent_fields9.tweetText,
            twitterUrl: (_contentComponent_fields10 = contentComponent.fields) === null || _contentComponent_fields10 === void 0 ? void 0 : _contentComponent_fields10.twitterUrl
        };
        else if (contentComponent.sys.contentType.sys.id === "callToAction") return {
            __typename: "CallToAction",
            title: (_contentComponent_fields11 = contentComponent.fields) === null || _contentComponent_fields11 === void 0 ? void 0 : _contentComponent_fields11.ctaTitleExternal,
            valueProposition: (_contentComponent_fields12 = contentComponent.fields) === null || _contentComponent_fields12 === void 0 ? void 0 : _contentComponent_fields12.valueProposition,
            ctaText: (_contentComponent_fields13 = contentComponent.fields) === null || _contentComponent_fields13 === void 0 ? void 0 : _contentComponent_fields13.ctaText,
            url: (_contentComponent_fields14 = contentComponent.fields) === null || _contentComponent_fields14 === void 0 ? void 0 : _contentComponent_fields14.ctaUrl,
            asset: $600c8041298aec96$var$formatAsset((_contentComponent_fields15 = contentComponent.fields) === null || _contentComponent_fields15 === void 0 ? void 0 : _contentComponent_fields15.ctaAsset),
            product: (_contentComponent_fields16 = contentComponent.fields) === null || _contentComponent_fields16 === void 0 ? void 0 : _contentComponent_fields16.product,
            dataBlueprintModule: (_contentComponent_fields17 = contentComponent.fields) === null || _contentComponent_fields17 === void 0 ? void 0 : _contentComponent_fields17.dataBlueprintModule
        };
        else if (contentComponent.sys.contentType.sys.id === "questionComponent") return {
            __typename: "QuestionComponent",
            questionTitle: (_contentComponent_fields18 = contentComponent.fields) === null || _contentComponent_fields18 === void 0 ? void 0 : _contentComponent_fields18.questionTitleExternal,
            answer: (_contentComponent_fields19 = contentComponent.fields) === null || _contentComponent_fields19 === void 0 ? void 0 : _contentComponent_fields19.answer,
            answerAsset: $600c8041298aec96$var$formatAsset((_contentComponent_fields20 = contentComponent.fields) === null || _contentComponent_fields20 === void 0 ? void 0 : _contentComponent_fields20.answerAsset)
        };
        else if (contentComponent.sys.contentType.sys.id === "callOutComponent") return {
            __typename: "CallOutComponent",
            title: (_contentComponent_fields21 = contentComponent.fields) === null || _contentComponent_fields21 === void 0 ? void 0 : _contentComponent_fields21.callOutComponentTitleExternal,
            callOutText: (_contentComponent_fields22 = contentComponent.fields) === null || _contentComponent_fields22 === void 0 ? void 0 : _contentComponent_fields22.callOutText,
            icon: $600c8041298aec96$var$formatAsset((_contentComponent_fields23 = contentComponent.fields) === null || _contentComponent_fields23 === void 0 ? void 0 : _contentComponent_fields23.callOutComponentIcon)
        };
        else // Default case for unknown component types
        return (0, $7Knp0._)({
            __typename: "UnknownComponent"
        }, contentComponent);
    });
    // Filter out unknown component types
    return formattedContentComponents.filter((component)=>component.__typename !== "UnknownComponent");
};
// eslint-disable-next-line complexity
const $600c8041298aec96$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $600c8041298aec96$var$UniformAgileTutorialBodyContent = (props)=>{
    const tutorialInstructionSteps = (0, $iSvIT.useMemo)(()=>$600c8041298aec96$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6z0RS.AgileTutorialBodyContent), (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        tutorialInstructionSteps: tutorialInstructionSteps
    }));
};
var $600c8041298aec96$export$2e2bcd8739ae039 = $600c8041298aec96$var$UniformAgileTutorialBodyContent;

});
parcelRegister("6z0RS", function(module, exports) {

$parcel$export(module.exports, "AgileTutorialBodyContent", function () { return $4438a4bc31146ac4$export$4b3aacc978c972ad; });
/* agile-tutorial-body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/jsx-key */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $1UUq1 = parcelRequire("1UUq1");

var $7eZEV = parcelRequire("7eZEV");

var $krNyQ = parcelRequire("krNyQ");

var $ZQ88u = parcelRequire("ZQ88u");
function $4438a4bc31146ac4$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
}
const $4438a4bc31146ac4$export$4b3aacc978c972ad = ({ tutorialInstructionSteps: tutorialInstructionSteps })=>{
    var _tutorialInstructionSteps_tutorialBodyTextContainer;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-hub-tutorial-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthze3t"
                ]),
                children: tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : tutorialInstructionSteps.tutorialUseStepTitle
            }),
            tutorialInstructionSteps === null || tutorialInstructionSteps === void 0 ? void 0 : (_tutorialInstructionSteps_tutorialBodyTextContainer = tutorialInstructionSteps.tutorialBodyTextContainer) === null || _tutorialInstructionSteps_tutorialBodyTextContainer === void 0 ? void 0 : _tutorialInstructionSteps_tutorialBodyTextContainer.map(// eslint-disable-next-line complexity
            (component)=>{
                var _component_asset, _component_asset1, _component_asset2;
                var _component_name, _component_text, _component_asset_url, _component_asset_description, _component_asset_contentType, _component_embeddedVideoAssetName, _component_name1, _component_name2, _component_proTipText, _component_title, _component_title1, _component_callOutText, _component_questionTitle, _component_questionTitle1, _component_answer;
                if ((0, $ZQ88u.isTextComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_rrz6idpf _1cobidpf _7exwv47k _1o6vv47k"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name !== void 0 ? _component_name : "",
                        text: $4438a4bc31146ac4$var$getRichText((_component_text = component === null || component === void 0 ? void 0 : component.text) !== null && _component_text !== void 0 ? _component_text : "")
                    })
                });
                else if ((0, $ZQ88u.isAssetComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: (_component_asset_url = component === null || component === void 0 ? void 0 : (_component_asset = component.asset) === null || _component_asset === void 0 ? void 0 : _component_asset.url) !== null && _component_asset_url !== void 0 ? _component_asset_url : "",
                            alt: (_component_asset_description = component === null || component === void 0 ? void 0 : (_component_asset1 = component.asset) === null || _component_asset1 === void 0 ? void 0 : _component_asset1.description) !== null && _component_asset_description !== void 0 ? _component_asset_description : "",
                            contentType: (_component_asset_contentType = component === null || component === void 0 ? void 0 : (_component_asset2 = component.asset) === null || _component_asset2 === void 0 ? void 0 : _component_asset2.contentType) !== null && _component_asset_contentType !== void 0 ? _component_asset_contentType : "",
                            className: (0, $esG4f.default)([
                                "_p12f1osq"
                            ])
                        }),
                        (component === null || component === void 0 ? void 0 : component.caption) && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "fine-print"
                            ]),
                            children: component === null || component === void 0 ? void 0 : component.caption
                        })
                    ]
                });
                else if ((0, $ZQ88u.isEmbedComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                    embedLink: (component === null || component === void 0 ? void 0 : component.embedded) || "",
                    thumbnail: component === null || component === void 0 ? void 0 : component.embedAssetOverlay,
                    title: (_component_embeddedVideoAssetName = component === null || component === void 0 ? void 0 : component.embeddedVideoAssetName) !== null && _component_embeddedVideoAssetName !== void 0 ? _component_embeddedVideoAssetName : ""
                });
                else if ((0, $ZQ88u.isProTipText)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "pro-tip",
                    label: (_component_name1 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name1 !== void 0 ? _component_name1 : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name2 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name2 !== void 0 ? _component_name2 : "",
                        text: $4438a4bc31146ac4$var$getRichText((_component_proTipText = component === null || component === void 0 ? void 0 : component.proTipText) !== null && _component_proTipText !== void 0 ? _component_proTipText : "")
                    })
                });
                else if ((0, $ZQ88u.isCallOutComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_title = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title !== void 0 ? _component_title : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_title1 = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title1 !== void 0 ? _component_title1 : "",
                        text: $4438a4bc31146ac4$var$getRichText((_component_callOutText = component === null || component === void 0 ? void 0 : component.callOutText) !== null && _component_callOutText !== void 0 ? _component_callOutText : "")
                    })
                });
                else if ((0, $ZQ88u.isQuestionComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_questionTitle = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle !== void 0 ? _component_questionTitle : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_questionTitle1 = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle1 !== void 0 ? _component_questionTitle1 : "",
                        text: $4438a4bc31146ac4$var$getRichText((_component_answer = component === null || component === void 0 ? void 0 : component.answer) !== null && _component_answer !== void 0 ? _component_answer : "")
                    })
                });
                return null;
            })
        ]
    });
};

});


parcelRegister("65qTS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12eae32653535cfa$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $e6ztu = parcelRequire("e6ztu");
const $12eae32653535cfa$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        articleIntroductionName: null,
        articleIntroductionDetails: null,
        articleIntroductionAsset: null,
        embedLink: null,
        componentizedIntroduction: null
    };
    const { articleintroduction: articleintroduction } = body;
    function getRichText(richText) {
        if (typeof richText === "string") return richText;
        return (0, $h2e6B.documentToHtmlString)(richText);
    }
    var _articleintroduction_articleIntroductionTitleExternal, _getRichText, _formatAsset, _articleintroduction_embedLink, _formatContentComponent;
    const formattedBody = {
        articleIntroductionName: (_articleintroduction_articleIntroductionTitleExternal = articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.articleIntroductionTitleExternal) !== null && _articleintroduction_articleIntroductionTitleExternal !== void 0 ? _articleintroduction_articleIntroductionTitleExternal : null,
        articleIntroductionDetails: (_getRichText = getRichText(articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.articleIntroductionDetails)) !== null && _getRichText !== void 0 ? _getRichText : null,
        articleIntroductionAsset: (_formatAsset = $12eae32653535cfa$var$formatAsset(articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.articleIntroductionAsset)) !== null && _formatAsset !== void 0 ? _formatAsset : null,
        embedLink: (_articleintroduction_embedLink = articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.embedLink) !== null && _articleintroduction_embedLink !== void 0 ? _articleintroduction_embedLink : null,
        componentizedIntroduction: (_formatContentComponent = $12eae32653535cfa$var$formatContentComponent(articleintroduction === null || articleintroduction === void 0 ? void 0 : articleintroduction.componentizedIntroduction)) !== null && _formatContentComponent !== void 0 ? _formatContentComponent : null
    };
    return formattedBody;
};
const $12eae32653535cfa$var$formatContentComponent = (contentComponents)=>{
    if (!contentComponents) return null;
    const formattedContentComponents = contentComponents.map(// eslint-disable-next-line complexity
    (contentComponent)=>{
        var _contentComponent_fields, _contentComponent_fields1, _contentComponent_fields2, _contentComponent_fields3, _contentComponent_fields4, _contentComponent_fields5, _contentComponent_fields6, _contentComponent_fields7, _contentComponent_fields8, _contentComponent_fields9, _contentComponent_fields10, _contentComponent_fields11, _contentComponent_fields12, _contentComponent_fields13, _contentComponent_fields14, _contentComponent_fields15, _contentComponent_fields16, _contentComponent_fields17, _contentComponent_fields18, _contentComponent_fields19, _contentComponent_fields20, _contentComponent_fields21, _contentComponent_fields22, _contentComponent_fields23;
        if (contentComponent.sys.contentType.sys.id === "textComponent") return {
            __typename: "TextComponent",
            name: (_contentComponent_fields = contentComponent.fields) === null || _contentComponent_fields === void 0 ? void 0 : _contentComponent_fields.textComponentNameExternal,
            text: (_contentComponent_fields1 = contentComponent.fields) === null || _contentComponent_fields1 === void 0 ? void 0 : _contentComponent_fields1.text
        };
        else if (contentComponent.sys.contentType.sys.id === "assetComponent") return {
            __typename: "AssetComponent",
            asset: $12eae32653535cfa$var$formatAsset((_contentComponent_fields2 = contentComponent.fields) === null || _contentComponent_fields2 === void 0 ? void 0 : _contentComponent_fields2.asset),
            caption: (_contentComponent_fields3 = contentComponent.fields) === null || _contentComponent_fields3 === void 0 ? void 0 : _contentComponent_fields3.assetCaption,
            assetRelatedText: (_contentComponent_fields4 = contentComponent.fields) === null || _contentComponent_fields4 === void 0 ? void 0 : _contentComponent_fields4.assetRelatedText
        };
        else if (contentComponent.sys.contentType.sys.id === "proTipComponent") {
            var _contentComponent_fields24, _contentComponent_fields25, _contentComponent_fields26, _contentComponent_fields27, _contentComponent_fields28, _contentComponent_fields29, _contentComponent_fields30;
            let proTipText = "";
            if ((_contentComponent_fields24 = contentComponent.fields) === null || _contentComponent_fields24 === void 0 ? void 0 : _contentComponent_fields24.proTipRichText) proTipText = (_contentComponent_fields25 = contentComponent.fields) === null || _contentComponent_fields25 === void 0 ? void 0 : _contentComponent_fields25.proTipRichText;
            else if ((_contentComponent_fields26 = contentComponent.fields) === null || _contentComponent_fields26 === void 0 ? void 0 : _contentComponent_fields26.proTipText) proTipText = (_contentComponent_fields27 = contentComponent.fields) === null || _contentComponent_fields27 === void 0 ? void 0 : _contentComponent_fields27.proTipText;
            else if ((_contentComponent_fields28 = contentComponent.fields) === null || _contentComponent_fields28 === void 0 ? void 0 : _contentComponent_fields28.proTipTextShort) proTipText = (_contentComponent_fields29 = contentComponent.fields) === null || _contentComponent_fields29 === void 0 ? void 0 : _contentComponent_fields29.proTipTextShort;
            return {
                __typename: "ProTipComponent",
                name: (_contentComponent_fields30 = contentComponent.fields) === null || _contentComponent_fields30 === void 0 ? void 0 : _contentComponent_fields30.proTipNameExternal,
                proTipText: proTipText
            };
        } else if (contentComponent.sys.contentType.sys.id === "embeddedVideoAsset") return {
            __typename: "EmbeddedVideoAsset",
            embeddedVideoAssetName: (_contentComponent_fields5 = contentComponent.fields) === null || _contentComponent_fields5 === void 0 ? void 0 : _contentComponent_fields5.embeddedVideoAssetNameExternal,
            embedded: (_contentComponent_fields6 = contentComponent.fields) === null || _contentComponent_fields6 === void 0 ? void 0 : _contentComponent_fields6.embedded,
            embedAssetOverlay: $12eae32653535cfa$var$formatAsset((_contentComponent_fields7 = contentComponent.fields) === null || _contentComponent_fields7 === void 0 ? void 0 : _contentComponent_fields7.embedAssetOverlay)
        };
        else if (contentComponent.sys.contentType.sys.id === "twitterComponent") return {
            __typename: "TwitterComponent",
            twitterComponentName: (_contentComponent_fields8 = contentComponent.fields) === null || _contentComponent_fields8 === void 0 ? void 0 : _contentComponent_fields8.twitterComponentExternalName,
            tweetText: (_contentComponent_fields9 = contentComponent.fields) === null || _contentComponent_fields9 === void 0 ? void 0 : _contentComponent_fields9.tweetText,
            twitterUrl: (_contentComponent_fields10 = contentComponent.fields) === null || _contentComponent_fields10 === void 0 ? void 0 : _contentComponent_fields10.twitterUrl
        };
        else if (contentComponent.sys.contentType.sys.id === "callToAction") return {
            __typename: "CallToAction",
            title: (_contentComponent_fields11 = contentComponent.fields) === null || _contentComponent_fields11 === void 0 ? void 0 : _contentComponent_fields11.ctaTitleExternal,
            valueProposition: (_contentComponent_fields12 = contentComponent.fields) === null || _contentComponent_fields12 === void 0 ? void 0 : _contentComponent_fields12.valueProposition,
            ctaText: (_contentComponent_fields13 = contentComponent.fields) === null || _contentComponent_fields13 === void 0 ? void 0 : _contentComponent_fields13.ctaText,
            url: (_contentComponent_fields14 = contentComponent.fields) === null || _contentComponent_fields14 === void 0 ? void 0 : _contentComponent_fields14.ctaUrl,
            asset: $12eae32653535cfa$var$formatAsset((_contentComponent_fields15 = contentComponent.fields) === null || _contentComponent_fields15 === void 0 ? void 0 : _contentComponent_fields15.ctaAsset),
            product: (_contentComponent_fields16 = contentComponent.fields) === null || _contentComponent_fields16 === void 0 ? void 0 : _contentComponent_fields16.product,
            dataBlueprintModule: (_contentComponent_fields17 = contentComponent.fields) === null || _contentComponent_fields17 === void 0 ? void 0 : _contentComponent_fields17.dataBlueprintModule
        };
        else if (contentComponent.sys.contentType.sys.id === "questionComponent") return {
            __typename: "QuestionComponent",
            questionTitle: (_contentComponent_fields18 = contentComponent.fields) === null || _contentComponent_fields18 === void 0 ? void 0 : _contentComponent_fields18.questionTitleExternal,
            answer: (_contentComponent_fields19 = contentComponent.fields) === null || _contentComponent_fields19 === void 0 ? void 0 : _contentComponent_fields19.answer,
            answerAsset: $12eae32653535cfa$var$formatAsset((_contentComponent_fields20 = contentComponent.fields) === null || _contentComponent_fields20 === void 0 ? void 0 : _contentComponent_fields20.answerAsset)
        };
        else if (contentComponent.sys.contentType.sys.id === "callOutComponent") return {
            __typename: "CallOutComponent",
            title: (_contentComponent_fields21 = contentComponent.fields) === null || _contentComponent_fields21 === void 0 ? void 0 : _contentComponent_fields21.callOutComponentTitleExternal,
            callOutText: (_contentComponent_fields22 = contentComponent.fields) === null || _contentComponent_fields22 === void 0 ? void 0 : _contentComponent_fields22.callOutText,
            icon: $12eae32653535cfa$var$formatAsset((_contentComponent_fields23 = contentComponent.fields) === null || _contentComponent_fields23 === void 0 ? void 0 : _contentComponent_fields23.callOutComponentIcon)
        };
        else // Default case for unknown component types
        return (0, $7Knp0._)({
            __typename: "UnknownComponent"
        }, contentComponent);
    });
    // Filter out unknown component types
    return formattedContentComponents.filter((component)=>component.__typename !== "UnknownComponent");
};
// eslint-disable-next-line complexity
const $12eae32653535cfa$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $12eae32653535cfa$var$UniformArticleIntroductionContent = (props)=>{
    const articleIntroduction = (0, $iSvIT.useMemo)(()=>$12eae32653535cfa$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $e6ztu.ArticleIntroductionContent), {
        articleIntroduction: articleIntroduction
    });
};
var $12eae32653535cfa$export$2e2bcd8739ae039 = $12eae32653535cfa$var$UniformArticleIntroductionContent;

});
parcelRegister("e6ztu", function(module, exports) {

$parcel$export(module.exports, "ArticleIntroductionContent", function () { return $079c0c2aa7b1ac7e$export$6ccfc3df312e7dbb; });
/* article-introduction-content.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/jsx-key */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $1UUq1 = parcelRequire("1UUq1");

var $7eZEV = parcelRequire("7eZEV");

var $krNyQ = parcelRequire("krNyQ");

var $ZQ88u = parcelRequire("ZQ88u");
function $079c0c2aa7b1ac7e$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
} // eslint-disable-next-line complexity
const $079c0c2aa7b1ac7e$export$6ccfc3df312e7dbb = ({ articleIntroduction: articleIntroduction })=>{
    var _articleIntroduction_componentizedIntroduction;
    var _articleIntroduction_articleIntroductionName, _articleIntroduction_articleIntroductionDetails, _articleIntroduction_embedLink, _articleIntroduction_articleIntroductionName1;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-hub-introduction-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            (articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName) && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthze3t"
                ]),
                children: articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName
            }),
            (articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionDetails) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthv47k"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    name: (_articleIntroduction_articleIntroductionName = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName) !== null && _articleIntroduction_articleIntroductionName !== void 0 ? _articleIntroduction_articleIntroductionName : "",
                    text: $079c0c2aa7b1ac7e$var$getRichText((_articleIntroduction_articleIntroductionDetails = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionDetails) !== null && _articleIntroduction_articleIntroductionDetails !== void 0 ? _articleIntroduction_articleIntroductionDetails : "")
                })
            }),
            (articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.embedLink) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                embedLink: (_articleIntroduction_embedLink = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.embedLink) !== null && _articleIntroduction_embedLink !== void 0 ? _articleIntroduction_embedLink : "",
                title: (_articleIntroduction_articleIntroductionName1 = articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionName) !== null && _articleIntroduction_articleIntroductionName1 !== void 0 ? _articleIntroduction_articleIntroductionName1 : "",
                thumbnail: articleIntroduction === null || articleIntroduction === void 0 ? void 0 : articleIntroduction.articleIntroductionAsset
            }),
            articleIntroduction === null || articleIntroduction === void 0 ? void 0 : (_articleIntroduction_componentizedIntroduction = articleIntroduction.componentizedIntroduction) === null || _articleIntroduction_componentizedIntroduction === void 0 ? void 0 : _articleIntroduction_componentizedIntroduction.map(// eslint-disable-next-line complexity
            (component)=>{
                var _component_asset, _component_asset1, _component_asset2;
                var _component_name, _component_text, _component_asset_url, _component_asset_description, _component_asset_contentType, _component_embeddedVideoAssetName, _component_name1, _component_name2, _component_proTipText, _component_title, _component_title1, _component_callOutText, _component_questionTitle, _component_questionTitle1, _component_answer;
                if ((0, $ZQ88u.isTextComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_rrz6idpf _1cobidpf _7exwv47k _1o6vv47k"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name !== void 0 ? _component_name : "",
                        text: $079c0c2aa7b1ac7e$var$getRichText((_component_text = component === null || component === void 0 ? void 0 : component.text) !== null && _component_text !== void 0 ? _component_text : "")
                    })
                });
                else if ((0, $ZQ88u.isAssetComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: (_component_asset_url = component === null || component === void 0 ? void 0 : (_component_asset = component.asset) === null || _component_asset === void 0 ? void 0 : _component_asset.url) !== null && _component_asset_url !== void 0 ? _component_asset_url : "",
                            alt: (_component_asset_description = component === null || component === void 0 ? void 0 : (_component_asset1 = component.asset) === null || _component_asset1 === void 0 ? void 0 : _component_asset1.description) !== null && _component_asset_description !== void 0 ? _component_asset_description : "",
                            contentType: (_component_asset_contentType = component === null || component === void 0 ? void 0 : (_component_asset2 = component.asset) === null || _component_asset2 === void 0 ? void 0 : _component_asset2.contentType) !== null && _component_asset_contentType !== void 0 ? _component_asset_contentType : "",
                            className: (0, $esG4f.default)([
                                "_p12f1osq"
                            ])
                        }),
                        (component === null || component === void 0 ? void 0 : component.caption) && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                "fine-print"
                            ]),
                            children: component === null || component === void 0 ? void 0 : component.caption
                        })
                    ]
                });
                else if ((0, $ZQ88u.isEmbedComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                    embedLink: (component === null || component === void 0 ? void 0 : component.embedded) || "",
                    thumbnail: component === null || component === void 0 ? void 0 : component.embedAssetOverlay,
                    title: (_component_embeddedVideoAssetName = component === null || component === void 0 ? void 0 : component.embeddedVideoAssetName) !== null && _component_embeddedVideoAssetName !== void 0 ? _component_embeddedVideoAssetName : ""
                });
                else if ((0, $ZQ88u.isProTipText)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "pro-tip",
                    label: (_component_name1 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name1 !== void 0 ? _component_name1 : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_name2 = component === null || component === void 0 ? void 0 : component.name) !== null && _component_name2 !== void 0 ? _component_name2 : "",
                        text: $079c0c2aa7b1ac7e$var$getRichText((_component_proTipText = component === null || component === void 0 ? void 0 : component.proTipText) !== null && _component_proTipText !== void 0 ? _component_proTipText : "")
                    })
                });
                else if ((0, $ZQ88u.isCallOutComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_title = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title !== void 0 ? _component_title : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_title1 = component === null || component === void 0 ? void 0 : component.title) !== null && _component_title1 !== void 0 ? _component_title1 : "",
                        text: $079c0c2aa7b1ac7e$var$getRichText((_component_callOutText = component === null || component === void 0 ? void 0 : component.callOutText) !== null && _component_callOutText !== void 0 ? _component_callOutText : "")
                    })
                });
                else if ((0, $ZQ88u.isQuestionComponent)(component)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), {
                    panelType: "highlight",
                    label: (_component_questionTitle = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle !== void 0 ? _component_questionTitle : "",
                    description: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                        name: (_component_questionTitle1 = component === null || component === void 0 ? void 0 : component.questionTitle) !== null && _component_questionTitle1 !== void 0 ? _component_questionTitle1 : "",
                        text: $079c0c2aa7b1ac7e$var$getRichText((_component_answer = component === null || component === void 0 ? void 0 : component.answer) !== null && _component_answer !== void 0 ? _component_answer : "")
                    })
                });
                return null;
            })
        ]
    });
};

});


parcelRegister("5DXmX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("6PX7I")).default; });

var $6PX7I = parcelRequire("6PX7I");

});
parcelRegister("6PX7I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28396434fb3285f3$export$2e2bcd8739ae039; });
/* background-video-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $gAJUc = parcelRequire("gAJUc");
const $28396434fb3285f3$var$containerStyles = null;
const $28396434fb3285f3$var$contentStyles = null;
const $28396434fb3285f3$var$svgOverlayStyles = null;
const $28396434fb3285f3$var$backgroundVideoStyles = null;
const $28396434fb3285f3$var$headingStyles = null;
const $28396434fb3285f3$var$descriptionStyles = null;
const $28396434fb3285f3$var$controlButtonStyles = null; // eslint-disable-next-line complexity
const $28396434fb3285f3$var$UniformBackgroundVideoContainer = (props)=>{
    const containerRef = (0, $iSvIT.useRef)(null);
    const [isVisible, setIsVisible] = (0, $iSvIT.useState)(false);
    const videoRef = (0, $iSvIT.useRef)(null);
    const [isPlaying, setPlaying] = (0, $iSvIT.useState)(false);
    const [hasEnded, setHasEnded] = (0, $iSvIT.useState)(false);
    const [currentVideoSource, setCurrentVideoSource] = (0, $iSvIT.useState)("");
    const [windowWidth, setWindowWidth] = (0, $iSvIT.useState)(typeof globalThis.window !== "undefined" ? globalThis.window.innerWidth : 1200);
    const [holeWidth, setHoleWidth] = (0, $iSvIT.useState)(1); // Separate width for rectangle
    const [holeHeight, setHoleHeight] = (0, $iSvIT.useState)(1); // Separate height for rectangle
    const [holeRadius, setHoleRadius] = (0, $iSvIT.useState)(300);
    const [containerDimensions, setContainerDimensions] = (0, $iSvIT.useState)({
        width: 0,
        height: 0
    });
    const intl = (0, $f6qj2.default)();
    const prefersReducedMotion = typeof globalThis.window !== "undefined" ? globalThis.window.matchMedia("(prefers-reduced-motion: reduce)").matches : false; // can turn the feature flag on to disable the overlay if it's glitchy
    const isAnimationOverlayEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7823AnimationOverlayOption);
    const computedWidth = containerDimensions.width || 1200;
    const computedHeight = containerDimensions.height || 700;
    const getVideoSource = (0, $iSvIT.useCallback)((width)=>{
        if (width >= 1024) return props.videoSourceDesktop;
        if (width >= 768) return props.videoSourceTablet;
        return props.videoSourceMobile;
    }, [
        props.videoSourceDesktop,
        props.videoSourceTablet,
        props.videoSourceMobile
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const handleResize = ()=>{
            if (typeof globalThis.window !== "undefined") setWindowWidth(globalThis.window.innerWidth);
        };
        const updateVideoSource = (newSource)=>{
            if (newSource === currentVideoSource) return;
            setCurrentVideoSource(newSource);
            if (!videoRef.current) return;
            if (isPlaying) {
                const currentTime = videoRef.current.currentTime;
                videoRef.current.src = newSource;
                videoRef.current.load();
                videoRef.current.currentTime = currentTime;
                videoRef.current.play().catch(()=>{});
            } else {
                videoRef.current.src = newSource;
                videoRef.current.load();
            }
        };
        const initialSource = getVideoSource(windowWidth);
        updateVideoSource(initialSource);
        if (typeof globalThis.window !== "undefined") {
            globalThis.window.addEventListener("resize", handleResize);
            return ()=>globalThis.window.removeEventListener("resize", handleResize);
        }
        return undefined;
    }, [
        windowWidth,
        currentVideoSource,
        isPlaying,
        getVideoSource
    ]);
    const togglePlay = ()=>{
        if (videoRef.current) {
            if (isPlaying) videoRef.current.pause();
            else videoRef.current.play().catch(()=>{});
        }
    };
    const handleVideoPlay = ()=>{
        setPlaying(true);
        setHasEnded(false);
    };
    const handleVideoPause = ()=>setPlaying(false);
    const handleVideoEnded = ()=>{
        setPlaying(false);
        setHasEnded(true);
    };
    const startHoleAnimation = (0, $iSvIT.useCallback)((containerElement)=>{
        const containerWidth = containerElement.offsetWidth;
        const containerHeight = containerElement.offsetHeight;
        setContainerDimensions({
            width: containerWidth,
            height: containerHeight
        });
        setTimeout(()=>{
            const startTime = Date.now();
            const duration = 800;
            const startSize = 1;
            const animationInterval = setInterval(()=>{
                const elapsed = Date.now() - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = 1 - Math.pow(1 - progress, 3); // ease-out cubic
                const currentHoleWidth = startSize + (containerWidth - startSize) * easedProgress;
                const currentHoleHeight = startSize + (containerHeight - startSize) * easedProgress;
                const currentRadius = 300 * (1 - Math.min(progress * 1.5, 1));
                setHoleWidth(currentHoleWidth);
                setHoleHeight(currentHoleHeight);
                setHoleRadius(currentRadius);
                if (progress >= 1) clearInterval(animationInterval);
            }, 16);
        }, 800);
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) {
                setIsVisible(true);
                if (videoRef.current && !prefersReducedMotion) videoRef.current.play().catch(()=>{});
                if (!prefersReducedMotion && containerRef.current && isAnimationOverlayEnabled) startHoleAnimation(containerRef.current);
                else if (containerRef.current && isAnimationOverlayEnabled) {
                    const containerWidth = containerRef.current.offsetWidth;
                    const containerHeight = containerRef.current.offsetHeight;
                    setContainerDimensions({
                        width: containerWidth,
                        height: containerHeight
                    });
                    setHoleWidth(containerWidth);
                    setHoleHeight(containerHeight);
                    setHoleRadius(0);
                }
            }
        }, {
            threshold: 0.3
        });
        if (containerRef.current) observer.observe(containerRef.current);
        return ()=>observer.disconnect();
    }, [
        prefersReducedMotion,
        startHoleAnimation,
        isAnimationOverlayEnabled
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: containerRef,
        className: (0, $esG4f.default)([
            "_bfhkmt5y _kqswh2mm _1reo15vq _18m915vq _4t3i1j7z _1gdlbcwg _1knekdgb"
        ]),
        style: {
            "--video-width-mobile": props.videoWidthMobile ? `${props.videoWidthMobile}px` : "500px",
            "--video-height-mobile": props.videoHeightMobile ? `${props.videoHeightMobile}px` : "700px",
            "--video-width-tablet": props.videoWidthTablet ? `${props.videoWidthTablet}px` : "800px",
            "--video-height-tablet": props.videoHeightTablet ? `${props.videoHeightTablet}px` : "1000px",
            "--video-width-desktop": props.videoWidthDesktop ? `${props.videoWidthDesktop}px` : "1200px",
            "--video-height-desktop": props.videoHeightDesktop ? `${props.videoHeightDesktop}px` : "700px",
            "--_1ex89o1": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("video", {
                ref: videoRef,
                src: currentVideoSource,
                muted: true,
                loop: props.videoLoop || false,
                playsInline: true,
                onPlay: handleVideoPlay,
                onPause: handleVideoPause,
                onEnded: handleVideoEnded,
                className: (0, $esG4f.default)([
                    "_kqswstnw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _152tidpf _u7coidpf _1pbykb7n _1e021l2x _rjxp1l2x _4t3i1j7z _1j7jwqo7 _19tlwqo7 _1gdlbcwg _nqop1vnc _1a5h1vnc _1knekdgb"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_tzy4idpf _kqswh2mm _1pbycs5v _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _y3gn1h6o _19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0qzwfg _u5f3zwfg _n3tdzwfg _19bvzwfg _p12f1osq _4t3i1osq _1bsbbxu3 _w19jrnt7 _v5641v33 _1s4p1erl _14u4kb7n _22qt1amc",
                    isVisible ? "animate-reveal" : ""
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_18s812pl _16cqcd5j",
                            "video-heading"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: props.videoHeading
                    }),
                    props.videoDescription && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_163ycd5j",
                            "video-description"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: props.videoDescription
                    }),
                    props.videoCta && props.videoCtaLink && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        href: props.videoCtaLink,
                        text: props.videoCta,
                        type: "primary",
                        bgColor: "bgBlackBlue"
                    })
                ]
            }),
            !hasEnded && /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                onClick: togglePlay,
                className: (0, $esG4f.default)([
                    "_80omtlke _tzy41ou4 _bfhk1j28 _syazcd5j _19it1axk _2rko17td _4t3i1ul9 _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1pbyegat _rjxppxbi _u7copxbi _16l4kb7n _w8l5dlk8"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                    "--_514je1": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.pill"))
                },
                children: isPlaying ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                    label: intl.formatMessage({
                        id: "uniform-video.pause",
                        defaultMessage: "Pause"
                    })
                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                    label: intl.formatMessage({
                        id: "uniform-video.play",
                        defaultMessage: "Play"
                    })
                })
            }),
            isAnimationOverlayEnabled && /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                viewBox: `0 0 ${computedWidth} ${computedHeight}`,
                preserveAspectRatio: "none",
                className: (0, $esG4f.default)([
                    "_kqswstnw _1pby11wp _lcxvglyw _1r04idpf _1bsb1osq _4t3i1osq _1lmqglyw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("mask", {
                            id: "hole-mask",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                    width: computedWidth,
                                    height: computedHeight,
                                    fill: "white"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                    x: computedWidth / 2 - holeWidth / 2,
                                    y: computedHeight / 2 - holeHeight / 2,
                                    width: holeWidth,
                                    height: holeHeight,
                                    rx: holeRadius,
                                    ry: holeRadius,
                                    fill: "black"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: computedWidth,
                        height: computedHeight,
                        fill: (0, $5ohHq.wacToken)("color.neutral.light0"),
                        mask: "url(#hole-mask)"
                    })
                ]
            })
        ]
    });
};
var $28396434fb3285f3$export$2e2bcd8739ae039 = $28396434fb3285f3$var$UniformBackgroundVideoContainer;

});
parcelRegister("gF60T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73df1d388ecc854df8671cdf3cc68b05>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c21523d4c5898645$var$_react = $c21523d4c5898645$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c21523d4c5898645$var$_baseNew = $c21523d4c5898645$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c21523d4c5898645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPauseOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c21523d4c5898645$var$VideoPauseOverlayIcon = (props)=>/*#__PURE__*/ $c21523d4c5898645$var$_react.default.createElement($c21523d4c5898645$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7 0a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$c21523d4c5898645$var$VideoPauseOverlayIcon.displayName = "VideoPauseOverlayIcon";
var $c21523d4c5898645$var$_default = module.exports.default = $c21523d4c5898645$var$VideoPauseOverlayIcon;

});

parcelRegister("7ShLR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2e3c8fcba4e62054ef71c09ada81e61>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5bbb5c804e3fea2a$var$_react = $5bbb5c804e3fea2a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5bbb5c804e3fea2a$var$_baseNew = $5bbb5c804e3fea2a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5bbb5c804e3fea2a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5bbb5c804e3fea2a$var$VideoPlayOverlayIcon = (props)=>/*#__PURE__*/ $5bbb5c804e3fea2a$var$_react.default.createElement($5bbb5c804e3fea2a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888z" clip-rule="evenodd"/>`
    }, props));
$5bbb5c804e3fea2a$var$VideoPlayOverlayIcon.displayName = "VideoPlayOverlayIcon";
var $5bbb5c804e3fea2a$var$_default = module.exports.default = $5bbb5c804e3fea2a$var$VideoPlayOverlayIcon;

});



parcelRegister("13r6t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3DJF0")).default; });

var $3DJF0 = parcelRequire("3DJF0");

});
parcelRegister("3DJF0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0ae596e2684c3fb$export$2e2bcd8739ae039; });
/* body-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $8M1Bj = parcelRequire("8M1Bj");

var $1UUq1 = parcelRequire("1UUq1");

var $8lB1y = parcelRequire("8lB1y");
const $a0ae596e2684c3fb$var$UniformBodyContent = ({ body: body })=>{
    const customComponentRenderer = (node)=>{
        switch(node.data.target.sys.contentType.sys.id){
            case "embeddedVideoAsset":
                {
                    var _embeddedVideoAssetData_embedAssetOverlay;
                    const embeddedVideoAssetData = node.data.target.fields;
                    const embeddedVideoThumbnail = (_embeddedVideoAssetData_embedAssetOverlay = embeddedVideoAssetData.embedAssetOverlay) === null || _embeddedVideoAssetData_embedAssetOverlay === void 0 ? void 0 : _embeddedVideoAssetData_embedAssetOverlay.fields;
                    if (!embeddedVideoAssetData.embedded) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
                    var _embeddedVideoAssetData_embeddedVideoAssetNameExternal;
                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.EmbeddedVideo), {
                            embedUrl: embeddedVideoAssetData.embedded,
                            thumbnail: embeddedVideoThumbnail ? {
                                src: embeddedVideoThumbnail.file.url,
                                alt: embeddedVideoThumbnail.description,
                                contentType: embeddedVideoThumbnail.file.contentType
                            } : undefined,
                            title: (_embeddedVideoAssetData_embeddedVideoAssetNameExternal = embeddedVideoAssetData.embeddedVideoAssetNameExternal) !== null && _embeddedVideoAssetData_embeddedVideoAssetNameExternal !== void 0 ? _embeddedVideoAssetData_embeddedVideoAssetNameExternal : ""
                        })
                    });
                }
            case "proTipComponent":
                {
                    const proTipComponentData = node.data.target.fields;
                    var _proTipComponentData_proTipText;
                    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_p12f1osq _1moupxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Panel), {
                            panelType: "pro-tip",
                            label: proTipComponentData.proTipNameExternal,
                            description: proTipComponentData.proTipRichText ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: (0, $h2e6B.documentToHtmlString)(proTipComponentData.proTipRichText)
                                }
                            }) : (_proTipComponentData_proTipText = proTipComponentData.proTipText) !== null && _proTipComponentData_proTipText !== void 0 ? _proTipComponentData_proTipText : ""
                        })
                    });
                }
            default:
                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {});
        }
    };
    const renderContentfulRichTextNodes = (nodes)=>{
        return nodes.map((node)=>{
            switch(node.nodeType){
                case "embedded-entry-block":
                    return customComponentRenderer(node);
                case "embedded-asset-block":
                    {
                        const embeddedAssetBlockData = node.data.target;
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: embeddedAssetBlockData.fields.file.url,
                            alt: embeddedAssetBlockData.fields.description,
                            style: $a0ae596e2684c3fb$var$embeddedItemStyles
                        });
                    }
                case "blockquote":
                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.PullQuote), {
                        quote: "",
                        quoteRichTextString: $a0ae596e2684c3fb$var$parseRichTextStringForOnlyContentInsideParagraphs((0, $h2e6B.documentToHtmlString)({
                            nodeType: (0, $8M1Bj.BLOCKS).DOCUMENT,
                            content: node.content,
                            data: {}
                        }))
                    });
                default:
                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
                        text: (0, $h2e6B.documentToHtmlString)({
                            nodeType: (0, $8M1Bj.BLOCKS).DOCUMENT,
                            content: [
                                node
                            ],
                            data: {}
                        })
                    });
            }
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _gy1pu2gc _1srcpxbi"
        ]),
        children: renderContentfulRichTextNodes(body.content)
    });
};
const $a0ae596e2684c3fb$var$embeddedItemStyles = {
    maxWidth: "100%",
    marginBlock: "var(--ds-space-200, 16px)"
};
const $a0ae596e2684c3fb$var$bodyContainerCss = null;
const $a0ae596e2684c3fb$var$parseRichTextStringForOnlyContentInsideParagraphs = (richTextString)=>{
    const paragraphRegex = /<p\b[^>]*>(.*?)<\/p>/gi;
    const matches = Array.from(richTextString.matchAll(paragraphRegex));
    return matches ? matches.map((m)=>m[1]).join() : richTextString;
};
var $a0ae596e2684c3fb$export$2e2bcd8739ae039 = $a0ae596e2684c3fb$var$UniformBodyContent;

});
parcelRegister("8M1Bj", function(module, exports) {
"use strict";
var $66340c49c763593e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $66340c49c763593e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $66340c49c763593e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $66340c49c763593e$var$__createBinding(exports1, m, p);
};
var $66340c49c763593e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $66340c49c763593e$var$__createBinding(result, mod, k);
    }
    $66340c49c763593e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaWithNodeType = module.exports.helpers = module.exports.EMPTY_DOCUMENT = module.exports.MARKS = module.exports.INLINES = module.exports.BLOCKS = void 0;

var $1tzW7 = parcelRequire("1tzW7");
Object.defineProperty(module.exports, "BLOCKS", {
    enumerable: true,
    get: function() {
        return $1tzW7.BLOCKS;
    }
});

var $7M716 = parcelRequire("7M716");
Object.defineProperty(module.exports, "INLINES", {
    enumerable: true,
    get: function() {
        return $7M716.INLINES;
    }
});

var $h1Tit = parcelRequire("h1Tit");
Object.defineProperty(module.exports, "MARKS", {
    enumerable: true,
    get: function() {
        return $h1Tit.MARKS;
    }
});

$66340c49c763593e$var$__exportStar((parcelRequire("2HY3w")), module.exports);

$66340c49c763593e$var$__exportStar((parcelRequire("69oZm")), module.exports);

$66340c49c763593e$var$__exportStar((parcelRequire("2KBrn")), module.exports);

var $4VZh4 = parcelRequire("4VZh4");
Object.defineProperty(module.exports, "EMPTY_DOCUMENT", {
    enumerable: true,
    get: function() {
        return $4VZh4.EMPTY_DOCUMENT;
    }
});

var $66340c49c763593e$var$helpers = $66340c49c763593e$var$__importStar((parcelRequire("kcFSF")));
module.exports.helpers = $66340c49c763593e$var$helpers;

var $jT4hL = parcelRequire("jT4hL");
Object.defineProperty(module.exports, "getSchemaWithNodeType", {
    enumerable: true,
    get: function() {
        return $jT4hL.getSchemaWithNodeType;
    }
});

});
parcelRegister("1tzW7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $1134601884ba055b$var$BLOCKS;
(function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($1134601884ba055b$var$BLOCKS || (module.exports.BLOCKS = $1134601884ba055b$var$BLOCKS = {}));

});

parcelRegister("7M716", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */ var $5a92757fe39538a5$var$INLINES;
(function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})($5a92757fe39538a5$var$INLINES || (module.exports.INLINES = $5a92757fe39538a5$var$INLINES = {}));

});

parcelRegister("h1Tit", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MARKS = void 0;
/**
 * Map of all Contentful marks.
 */ var $c65d6c7b23d33ecb$var$MARKS;
(function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})($c65d6c7b23d33ecb$var$MARKS || (module.exports.MARKS = $c65d6c7b23d33ecb$var$MARKS = {}));

});

parcelRegister("2HY3w", function(module, exports) {
"use strict";
var $1f8e2ec2e0d9f56b$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $1f8e2ec2e0d9f56b$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1_MARKS = module.exports.V1_NODE_TYPES = module.exports.TEXT_CONTAINERS = module.exports.HEADINGS = module.exports.CONTAINERS = module.exports.VOID_BLOCKS = module.exports.TABLE_BLOCKS = module.exports.LIST_ITEM_BLOCKS = module.exports.TOP_LEVEL_BLOCKS = void 0;

var $1tzW7 = parcelRequire("1tzW7");

var $7M716 = parcelRequire("7M716");

var $h1Tit = parcelRequire("h1Tit");
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */ module.exports.TOP_LEVEL_BLOCKS = [
    $1tzW7.BLOCKS.PARAGRAPH,
    $1tzW7.BLOCKS.HEADING_1,
    $1tzW7.BLOCKS.HEADING_2,
    $1tzW7.BLOCKS.HEADING_3,
    $1tzW7.BLOCKS.HEADING_4,
    $1tzW7.BLOCKS.HEADING_5,
    $1tzW7.BLOCKS.HEADING_6,
    $1tzW7.BLOCKS.OL_LIST,
    $1tzW7.BLOCKS.UL_LIST,
    $1tzW7.BLOCKS.HR,
    $1tzW7.BLOCKS.QUOTE,
    $1tzW7.BLOCKS.EMBEDDED_ENTRY,
    $1tzW7.BLOCKS.EMBEDDED_ASSET,
    $1tzW7.BLOCKS.EMBEDDED_RESOURCE,
    $1tzW7.BLOCKS.TABLE
];
/**
 * Array of all allowed block types inside list items
 */ module.exports.LIST_ITEM_BLOCKS = [
    $1tzW7.BLOCKS.PARAGRAPH,
    $1tzW7.BLOCKS.HEADING_1,
    $1tzW7.BLOCKS.HEADING_2,
    $1tzW7.BLOCKS.HEADING_3,
    $1tzW7.BLOCKS.HEADING_4,
    $1tzW7.BLOCKS.HEADING_5,
    $1tzW7.BLOCKS.HEADING_6,
    $1tzW7.BLOCKS.OL_LIST,
    $1tzW7.BLOCKS.UL_LIST,
    $1tzW7.BLOCKS.HR,
    $1tzW7.BLOCKS.QUOTE,
    $1tzW7.BLOCKS.EMBEDDED_ENTRY,
    $1tzW7.BLOCKS.EMBEDDED_ASSET,
    $1tzW7.BLOCKS.EMBEDDED_RESOURCE
];
module.exports.TABLE_BLOCKS = [
    $1tzW7.BLOCKS.TABLE,
    $1tzW7.BLOCKS.TABLE_ROW,
    $1tzW7.BLOCKS.TABLE_CELL,
    $1tzW7.BLOCKS.TABLE_HEADER_CELL
];
/**
 * Array of all void block types
 */ module.exports.VOID_BLOCKS = [
    $1tzW7.BLOCKS.HR,
    $1tzW7.BLOCKS.EMBEDDED_ENTRY,
    $1tzW7.BLOCKS.EMBEDDED_ASSET,
    $1tzW7.BLOCKS.EMBEDDED_RESOURCE
];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */ module.exports.CONTAINERS = ($1f8e2ec2e0d9f56b$var$_a = {}, $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.OL_LIST] = [
    $1tzW7.BLOCKS.LIST_ITEM
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.UL_LIST] = [
    $1tzW7.BLOCKS.LIST_ITEM
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.LIST_ITEM] = module.exports.LIST_ITEM_BLOCKS, $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.QUOTE] = [
    $1tzW7.BLOCKS.PARAGRAPH
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.TABLE] = [
    $1tzW7.BLOCKS.TABLE_ROW
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.TABLE_ROW] = [
    $1tzW7.BLOCKS.TABLE_CELL,
    $1tzW7.BLOCKS.TABLE_HEADER_CELL
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.TABLE_CELL] = [
    $1tzW7.BLOCKS.PARAGRAPH,
    $1tzW7.BLOCKS.UL_LIST,
    $1tzW7.BLOCKS.OL_LIST
], $1f8e2ec2e0d9f56b$var$_a[$1tzW7.BLOCKS.TABLE_HEADER_CELL] = [
    $1tzW7.BLOCKS.PARAGRAPH
], $1f8e2ec2e0d9f56b$var$_a);
/**
 * Array of all heading levels
 */ module.exports.HEADINGS = [
    $1tzW7.BLOCKS.HEADING_1,
    $1tzW7.BLOCKS.HEADING_2,
    $1tzW7.BLOCKS.HEADING_3,
    $1tzW7.BLOCKS.HEADING_4,
    $1tzW7.BLOCKS.HEADING_5,
    $1tzW7.BLOCKS.HEADING_6
];
/**
 * Array of all block types that may contain text and inline nodes.
 */ module.exports.TEXT_CONTAINERS = $1f8e2ec2e0d9f56b$var$__spreadArray([
    $1tzW7.BLOCKS.PARAGRAPH
], module.exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */ module.exports.V1_NODE_TYPES = [
    $1tzW7.BLOCKS.DOCUMENT,
    $1tzW7.BLOCKS.PARAGRAPH,
    $1tzW7.BLOCKS.HEADING_1,
    $1tzW7.BLOCKS.HEADING_2,
    $1tzW7.BLOCKS.HEADING_3,
    $1tzW7.BLOCKS.HEADING_4,
    $1tzW7.BLOCKS.HEADING_5,
    $1tzW7.BLOCKS.HEADING_6,
    $1tzW7.BLOCKS.OL_LIST,
    $1tzW7.BLOCKS.UL_LIST,
    $1tzW7.BLOCKS.LIST_ITEM,
    $1tzW7.BLOCKS.HR,
    $1tzW7.BLOCKS.QUOTE,
    $1tzW7.BLOCKS.EMBEDDED_ENTRY,
    $1tzW7.BLOCKS.EMBEDDED_ASSET,
    $7M716.INLINES.HYPERLINK,
    $7M716.INLINES.ENTRY_HYPERLINK,
    $7M716.INLINES.ASSET_HYPERLINK,
    $7M716.INLINES.EMBEDDED_ENTRY,
    "text"
];
/**
 * Marks before `superscript` & `subscript` release.
 */ module.exports.V1_MARKS = [
    $h1Tit.MARKS.BOLD,
    $h1Tit.MARKS.CODE,
    $h1Tit.MARKS.ITALIC,
    $h1Tit.MARKS.UNDERLINE
];

});

parcelRegister("69oZm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2KBrn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4VZh4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DOCUMENT = void 0;

var $1tzW7 = parcelRequire("1tzW7");
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ module.exports.EMPTY_DOCUMENT = {
    nodeType: $1tzW7.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $1tzW7.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: "text",
                    value: "",
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};

});

parcelRegister("kcFSF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInline = $eb556a49f6e32746$var$isInline;
module.exports.isBlock = $eb556a49f6e32746$var$isBlock;
module.exports.isText = $eb556a49f6e32746$var$isText;

var $1tzW7 = parcelRequire("1tzW7");

var $7M716 = parcelRequire("7M716");
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $eb556a49f6e32746$var$hasValue(obj, value) {
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var key = _a[_i];
        if (value === obj[key]) return true;
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */ function $eb556a49f6e32746$var$isInline(node) {
    return $eb556a49f6e32746$var$hasValue($7M716.INLINES, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */ function $eb556a49f6e32746$var$isBlock(node) {
    return $eb556a49f6e32746$var$hasValue($1tzW7.BLOCKS, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */ function $eb556a49f6e32746$var$isText(node) {
    return node.nodeType === "text";
}

});

parcelRegister("jT4hL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaWithNodeType = $e7a67a5f8e434497$var$getSchemaWithNodeType;
function $e7a67a5f8e434497$var$getSchemaWithNodeType(nodeType) {
    try {
        return require("./generated/".concat(nodeType, ".json"));
    } catch (error) {
        throw new Error('Schema for nodeType "'.concat(nodeType, '" was not found.'));
    }
}

});




parcelRegister("fNs39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("fgHWA")).default; });

var $fgHWA = parcelRequire("fgHWA");

});
parcelRegister("fgHWA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bde48239d505432b$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $53lGm = parcelRequire("53lGm");

var $3FxzV = parcelRequire("3FxzV");

var $51Zx0 = parcelRequire("51Zx0");
const $bde48239d505432b$var$UniformCollectionPricingHero = (props)=>{
    if (props.collectionType === "teamwork") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $51Zx0.TeamworkCollectionPricingHero), {});
    if (props.collectionType === "strategy") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3FxzV.StrategyCollectionPricingHero), {});
    if (props.collectionType === "service") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $53lGm.ServiceCollectionPricingHero), {});
    return null;
};
var $bde48239d505432b$export$2e2bcd8739ae039 = $bde48239d505432b$var$UniformCollectionPricingHero;

});
parcelRegister("53lGm", function(module, exports) {

$parcel$export(module.exports, "ServiceCollectionPricingHero", function () { return $14ea60a252a718ba$export$5eff9997197d8e50; });

var $loA2J = parcelRequire("loA2J");

var $juk3G = parcelRequire("juk3G");
const $14ea60a252a718ba$export$5eff9997197d8e50 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $juk3G.CollectionPricingHero), {
        orientation: "vertical",
        collectionImage: {
            height: 48,
            width: 168,
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wq7706lsya8q6fb1sj2k15h48h450ssr.svg",
            alt: "Service Collection"
        },
        products: [
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/7jcq40x67167gax15ux7b27r5r575tk5.svg",
                    alt: "Jira Service Management"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/466ke7l5j3i276s3p7k5660c525ru38d.svg",
                    alt: "Customer Service Management"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hgm0up275i80h6m7b5j3f8t68a7fcp4.svg",
                    alt: "Assets"
                }
            },
            {
                name: "Rovo",
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6kq772n08c357g2p82f8bnw824do06dn.svg",
                    alt: "Rovo"
                }
            }
        ]
    });
};

});

parcelRegister("3FxzV", function(module, exports) {

$parcel$export(module.exports, "StrategyCollectionPricingHero", function () { return $fda3d9fdacb70743$export$4a5cc933f6e8553a; });

var $loA2J = parcelRequire("loA2J");

var $juk3G = parcelRequire("juk3G");
const $fda3d9fdacb70743$export$4a5cc933f6e8553a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $juk3G.CollectionPricingHero), {
        collectionImage: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5j2mvlle35t45d0e48ye5tqpoe0m63gu.svg",
            alt: "Strategy Collection"
        },
        products: [
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/hd3m515u7j3s37rldpf0dgeb7m383j4s.svg",
                    alt: "Align"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/241h1u1khig63kccl1fe3hisqom3q007/fl_keep_metadata/Apps-Talent.svg",
                    alt: "Talent"
                }
            },
            {
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/24e3l0ul76q4fpa4l2mmc7t00k202322.svg",
                    alt: "Focus"
                }
            }
        ]
    });
};

});



parcelRegister("jMHQc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("jiwkx")).default; });

var $jiwkx = parcelRequire("jiwkx");

});
parcelRegister("jiwkx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5443937a92fde21e$export$2e2bcd8739ae039; });
/* confluence-animated-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $2bAHw = parcelRequire("2bAHw");

var $aiugz = parcelRequire("aiugz");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $5443937a92fde21e$var$sectionCss = null;
const $5443937a92fde21e$var$cardContainerCss = null;
const $5443937a92fde21e$var$cardCss = null;
const $5443937a92fde21e$var$cardTextCss = null;
const $5443937a92fde21e$var$cardHeadingCss = null;
const $5443937a92fde21e$var$cardBodyTextCss = null;
const $5443937a92fde21e$var$controlButtonStyles = null;
const $5443937a92fde21e$var$videoContainerCss = null;
const $5443937a92fde21e$export$235b37640a653467 = ({ title: title, bodytext: bodytext, image: image, altText: altText })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    const [isPlaying, setPlaying] = (0, $iSvIT.useState)(false);
    const intl = (0, $f6qj2.default)();
    const prefersReducedMotion = typeof window !== "undefined" ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
    const togglePlay = ()=>{
        if (videoRef.current) {
            if (isPlaying) videoRef.current.pause();
            else videoRef.current.play().catch(()=>{});
        }
    };
    const handleVideoPlay = ()=>setPlaying(true);
    const handleVideoPause = ()=>setPlaying(false);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulp7vkz _kqswh2mm _1k9hgrho _1mj31wqb _162p1nty _1xjr1nty _1scc1gha _1nr41gha _1axucs5v _15z31nut _hauj1nut _188c150m _y5pt150m _11za1o02 _1rgq1o02 _tnzz120m _s118120m _ikf21klr _18zx1klr _zcbv1osq _mezj1osq _12l01wug _bna71wug _eq9p15vq _pzs515vq _175j15vq _dknm15vq _1gbl1wug _1cr61wug _qpgx1wug _1hlx1wug _1d2pidpf _1874idpf _s93b1wug _10ew1wug _1th61xym _k9x81xym _1wi11m52 _1biu1m52 _ldg0vwyg _dzwgvwyg _8wcmcd5j _d3lpcd5j _1dhb1cd0 _t1ov1cd0 _1sdaagmp _ktt3agmp",
            "single-hero-card"
        ]),
        style: {
            "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: "text-container",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_gxfkidpf _tfg1idpf _16yqidpf _15zyidpf _14dwidpf _1u6jidpf _1ikgidpf _1p3yidpf _1niwidpf _a15ridpf _12k0idpf _1fx6idpf _104aidpf _10pqidpf _5ybeidpf _1avnidpf _1cmpidpf _174lidpf _tlu6idpf _kopkidpf _4s33idpf _lychidpf _zzhoidpf _x9vnidpf _65gh10nf _18ko10nf _17ie10nf _1dlt10nf _1t9o10nf _1x5u10nf _1g4p1ejb _1l3z1ejb _1qkw1ejb _8znu1ejb _vh191ejb _ret01ejb _kgcl1nn1 _1m1k1nn1 _b08d1nn1 _1bau1nn1 _zmdp1nn1 _1r881nn1",
                            "_kdam16zr _19pkidpf _2hwxidpf _otyr1kwk _18u0idpf _v5644yh6 _pxcp4jg8 _60qani7l _1kpj1qqw",
                            "card-text card-heading"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformRichTextNode), {
                            node: title["root"] || title
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1axaidpf _420lidpf _195sidpf _thjjidpf _jhbppxbi _1yq31k8s _zcsk1nn1",
                            "_kdam16zr _19pkidpf _2hwxidpf _otyr1kwk _18u0idpf _v5644yh6 _pxcp4jg8 _60qani7l _1kpj1qqw",
                            "card-text card-body"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformRichTextNode), {
                            node: bodytext["root"] || bodytext
                        })
                    })
                ]
            }),
            image.includes(".mp4") ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _npsn1dfr _1y2k1osq _z18o1osq",
                    "imagery video video-container"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("video", {
                        ref: videoRef,
                        src: image,
                        autoPlay: !prefersReducedMotion,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        onPlay: handleVideoPlay,
                        onPause: handleVideoPause,
                        onLoadedMetadata: ()=>{
                            if (videoRef.current && !prefersReducedMotion) videoRef.current.play().catch(()=>{}); // autoplay by default but if browser restrictions prevent it button will show in play state
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                        className: (0, $esG4f.default)([
                            "_80omtlke _tzy41ou4 _bfhk1j28 _syazcd5j _19it1axk _2rko17td _4t3i1ul9 _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1pbyegat _rjxppxbi _u7co1jfw _16l4kb7n _w8l5dlk8",
                            "control-button"
                        ]),
                        onClick: togglePlay,
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                            "--_514je1": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.pill"))
                        },
                        children: isPlaying ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                            label: intl.formatMessage({
                                id: "uniform-video.pause",
                                defaultMessage: "Pause"
                            })
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                            label: intl.formatMessage({
                                id: "uniform-video.play",
                                defaultMessage: "Play"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                src: image,
                alt: altText
            })
        ]
    });
};
const $5443937a92fde21e$var$UniformConfluenceAnimatedHero = ({ confluenceHeroCards: confluenceHeroCards, imagesWidth: imagesWidth, imagesHeight: imagesHeight, flattenData: flattenData = true })=>{
    if (flattenData) confluenceHeroCards = (0, $2bAHw.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    confluenceHeroCards);
    const [inview, setInview] = (0, $iSvIT.useState)(false);
    const [hasScrolled, setHasScrolled] = (0, $iSvIT.useState)(false);
    const [moveUpValue, setMoveUpValue] = (0, $iSvIT.useState)(120);
    const containerRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(()=>{
        const handleScroll = ()=>{
            if (window.scrollY <= 50) {
                setInview(false);
                setHasScrolled(false);
                return;
            } else setHasScrolled(true);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        if (!hasScrolled || !containerRef.current) return;
        const io = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) setInview(true);
            });
        }, {
            threshold: 0.5
        });
        io.observe(containerRef.current);
        return ()=>{
            io.disconnect();
        };
    }, [
        hasScrolled
    ]);
    (0, $iSvIT.useEffect)(()=>{
        var _document_fonts_ready, _document_fonts, _document;
        const updateMoveUpValue = ()=>{
            if (!containerRef.current) return;
            const textContainers = containerRef.current.querySelectorAll(".text-container");
            let maxHeight = 0;
            textContainers.forEach((container)=>{
                const height = container.offsetHeight;
                maxHeight = Math.max(maxHeight, height);
            });
            const calculatedMoveUp = maxHeight + 16;
            setMoveUpValue(calculatedMoveUp);
        };
        const timeoutId = setTimeout(updateMoveUpValue, 100);
        (_document = document) === null || _document === void 0 ? void 0 : (_document_fonts = _document.fonts) === null || _document_fonts === void 0 ? void 0 : (_document_fonts_ready = _document_fonts.ready) === null || _document_fonts_ready === void 0 ? void 0 : _document_fonts_ready.then(updateMoveUpValue);
        window.addEventListener("resize", updateMoveUpValue);
        return ()=>{
            clearTimeout(timeoutId);
            window.removeEventListener("resize", updateMoveUpValue);
        };
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_11q71ybm _v5641r9r _lwq31qpa _ia4wwomy _mbuvwomy",
            "scroll-hero" + (inview ? " inview" : " outview")
        ]),
        style: {
            "--moveup": `-${moveUpValue}px`,
            "--imagesWidth": imagesWidth,
            "--imagesHeight": imagesHeight,
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            ref: containerRef,
            className: (0, $esG4f.default)([
                "_1e0c11p5 _1bsb1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _zulp14hz _1dsl1tcg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx _1vsw1vi7 _1j8b16hb _1wafpxbi _1bah1h6o _1ojfg8ja _3qvcg8ja _1utg36zz _1fjs36zz _12n71qqw _xlt1xncg _131yxncg _bkwyglyw _xon5glyw _128dglyw _q8ukglyw _4y3qglyw _uzo21qqw",
                inview ? "inview" : "outview"
            ]),
            style: {
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
            },
            children: confluenceHeroCards.map((card, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($5443937a92fde21e$export$235b37640a653467, {
                    title: card.cardTitle,
                    bodytext: card.cardDescription,
                    image: card.cardImageOrVideo,
                    altText: card.cardImageAlt
                }, index))
        })
    });
};
var $5443937a92fde21e$export$2e2bcd8739ae039 = $5443937a92fde21e$var$UniformConfluenceAnimatedHero;

});


parcelRegister("kuzIk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("gGkrX")).default; });

var $gGkrX = parcelRequire("gGkrX");

});
parcelRegister("gGkrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f3e06674b05ade7$export$2e2bcd8739ae039; });
/* connector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $2bAHw = parcelRequire("2bAHw");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $haYnf = parcelRequire("haYnf");

var $icTgC = parcelRequire("icTgC");

var $lKfOm = parcelRequire("lKfOm");
const $2f3e06674b05ade7$var$UniformConnector = ({ title: title, text: text, linkText: linkText, linkHref: linkHref, customerQuotes: customerQuotes, mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos, flattenData: flattenData = true })=>{
    if (flattenData) {
        customerQuotes = (0, $2bAHw.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        customerQuotes); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mobileLogos = (0, $2bAHw.flattenValues)(mobileLogos); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tabletLogos = (0, $2bAHw.flattenValues)(tabletLogos); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        desktopLogos = (0, $2bAHw.flattenValues)(desktopLogos);
    }
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1rjc1epz _bfhk1hlo _1e0c1txw _2lx21bp4 _zulpoahv"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $haYnf.UniformColumnLayout), {
                layout: "5-7",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_cg41cd5j _125xcd5j _xsmr1h6o",
                            "contentBlock"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1pfhxy5q _6rthu2gc _476dze3t"
                                ]),
                                children: title
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_1mouze3t"
                                ]),
                                children: text
                            }),
                            linkText && linkHref && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1pfh1ejb _6rthxy5q _srwz1ejb"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                    text: linkText,
                                    href: linkHref,
                                    type: "primary",
                                    bgColor: "bgBlackBlue"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $icTgC.CustomerQuoteCarousel), {
                        customerQuotes: customerQuotes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $lKfOm.LogosMarquee), {
                mobileLogos: mobileLogos,
                tabletLogos: tabletLogos,
                desktopLogos: desktopLogos
            })
        ]
    });
};
var $2f3e06674b05ade7$export$2e2bcd8739ae039 = $2f3e06674b05ade7$var$UniformConnector;
const $2f3e06674b05ade7$var$containerCss = null;
const $2f3e06674b05ade7$var$lightTextCss = null;
const $2f3e06674b05ade7$var$titleCss = null;
const $2f3e06674b05ade7$var$textCss = null;
const $2f3e06674b05ade7$var$linkCss = null;

});
parcelRegister("icTgC", function(module, exports) {

$parcel$export(module.exports, "CustomerQuoteCarousel", function () { return $7dc39b09f5bfce5f$export$abab76d12bbd8406; });
/* customer-quote-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $c9BrD = parcelRequire("c9BrD");

var $eAfof = parcelRequire("eAfof");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");
const $7dc39b09f5bfce5f$var$messages = {
    previousSlide: {
        id: "customer-quote-carousel.previous-slide",
        defaultMessage: "Previous slide"
    },
    nextSlide: {
        id: "customer-quote-carousel.previous-slide",
        defaultMessage: "Previous slide"
    }
};
const $7dc39b09f5bfce5f$export$abab76d12bbd8406 = ({ customerQuotes: customerQuotes })=>{
    const [activeQuoteIndex, setactiveQuoteIndex] = (0, $iSvIT.useState)(0);
    const prevSlide = ()=>{
        if (activeQuoteIndex > 0) setactiveQuoteIndex(activeQuoteIndex - 1);
    };
    const nextSlide = ()=>{
        if (activeQuoteIndex < customerQuotes.length - 1) setactiveQuoteIndex(activeQuoteIndex + 1);
    };
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "aria-hidden": true,
                className: (0, $esG4f.default)([
                    "_nd5lgbua",
                    "_1yt4xy5q _15tx1ejb"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _4t3i1ns9",
                        "_1q5188uy"
                    ]),
                    children: customerQuotes.map((customerQuote, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_nd5lgbua",
                                "_3um015vq",
                                "_tfwpidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.PullQuote), {
                                quote: customerQuote.quote,
                                authorName: customerQuote.advocateName,
                                authorDetails: customerQuote.advocateJobTitle
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_2rkovwyg _bfhk1nc2 _1yt4xy5q _4t3i1ns9 _1e0c1txw _2lx21bp4 _zulp1ejb _15tx1ejb",
                    "_cg4111ib _125x11ib _1tjq11ib",
                    "_nd5lgbua"
                ]),
                style: {
                    "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                    "--_yrk0lp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark100")),
                    "--_44ufl2": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _1bah1yb4 _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c11p5 _4t3i1ns9"
                                ]),
                                children: customerQuotes.map(({ companyLogo: companyLogo }, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        "aria-hidden": index !== activeQuoteIndex,
                                        className: (0, $esG4f.default)([
                                            "_nd5lgbua _3um015tv _1bsb11ux _4t3i1ylp"
                                        ]),
                                        style: {
                                            "--_neqv2r": (0, $43MIc.default)(index === activeQuoteIndex ? "visible" : "hidden")
                                        },
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image // @ts-ignore
                                        ), {
                                            src: companyLogo[0].src,
                                            alt: companyLogo[0].alt,
                                            style: {
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                objectPosition: "left"
                                            }
                                        })
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _4cvr1h6o _zulputpp"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                        onClick: prevSlide,
                                        disabled: activeQuoteIndex === 0,
                                        "aria-label": intl.formatMessage($7dc39b09f5bfce5f$var$messages.previousSlide),
                                        className: (0, $esG4f.default)([
                                            "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1x1a73ad _v42d73ad _1tc8pmk4 _64781yg0"
                                        ]),
                                        style: {
                                            "--_1ljptrt": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light1000")),
                                            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                                        },
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3"
                                            ]),
                                            style: {
                                                "--_qeag6c": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark400")),
                                                "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500"))
                                            },
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c9BrD))), {
                                                label: intl.formatMessage($7dc39b09f5bfce5f$var$messages.previousSlide)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_cg4111ib _125x11ib _1tjq11ib",
                                            "_1bsb183y _1mouidpf"
                                        ]),
                                        style: {
                                            "--_44ufl2": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1000"))
                                        },
                                        children: `${activeQuoteIndex + 1}/${customerQuotes.length}`
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                        onClick: nextSlide,
                                        disabled: activeQuoteIndex === customerQuotes.length - 1,
                                        "aria-label": intl.formatMessage($7dc39b09f5bfce5f$var$messages.nextSlide),
                                        className: (0, $esG4f.default)([
                                            "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1x1a73ad _v42d73ad _1tc8pmk4 _64781yg0"
                                        ]),
                                        style: {
                                            "--_1ljptrt": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light1000")),
                                            "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                                        },
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3"
                                            ]),
                                            style: {
                                                "--_qeag6c": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark400")),
                                                "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500"))
                                            },
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAfof))), {
                                                label: intl.formatMessage($7dc39b09f5bfce5f$var$messages.nextSlide)
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _4t3i1ns9",
                            "_tfwpidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.PullQuote // @ts-ignore
                        ), {
                            quote: customerQuotes[activeQuoteIndex].quote,
                            authorName: // @ts-ignore
                            customerQuotes[activeQuoteIndex].advocateName,
                            authorDetails: // @ts-ignore
                            customerQuotes[activeQuoteIndex].advocateJobTitle
                        })
                    })
                ]
            })
        ]
    });
};
const $7dc39b09f5bfce5f$var$lightTextCss = null;
const $7dc39b09f5bfce5f$var$carouselContainerCss = null;
const $7dc39b09f5bfce5f$var$logoAndButtonContainerCss = null;
const $7dc39b09f5bfce5f$var$gridCss = null;
const $7dc39b09f5bfce5f$var$overlapGridItemCss = null;
const $7dc39b09f5bfce5f$var$buttonsContainerCss = null;
const $7dc39b09f5bfce5f$var$slideNumberCss = null;
const $7dc39b09f5bfce5f$var$buttonCss = null;
const $7dc39b09f5bfce5f$var$chevronCirlceCss = null;
const $7dc39b09f5bfce5f$var$hiddenCarouselContainerCss = null;
const $7dc39b09f5bfce5f$var$hiddenQuoteCss = null;
const $7dc39b09f5bfce5f$var$visibilityHiddenCss = null;
const $7dc39b09f5bfce5f$var$overrideQuotePadding = null;

});

parcelRegister("lKfOm", function(module, exports) {

$parcel$export(module.exports, "LogosMarquee", function () { return $b383584eb4fcfdf4$export$143c39d1bfa1977e; });
/* logos-marquee.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $haYnf = parcelRequire("haYnf");
const $b383584eb4fcfdf4$var$Logo = ({ src: src, href: href, alt: alt, ariaHidden: ariaHidden, tabIndex: tabIndex })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
        "aria-hidden": ariaHidden,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: href,
            tabIndex: tabIndex,
            className: (0, $esG4f.default)([
                "_1e0c1txw _bfhk1nc2 _2rkovwyg _irr3gc2p"
            ]),
            style: {
                "--_yrk0lp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark100")),
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4t3i1wqb _1bsb1wqb _19pk19bv _2hwx19bv _otyr19bv _18u019bv"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: src,
                    alt: alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $b383584eb4fcfdf4$export$143c39d1bfa1977e = ({ mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos })=>{
    const [running, setRunning] = (0, $iSvIT.useState)(true);
    tabletLogos = (tabletLogos === null || tabletLogos === void 0 ? void 0 : tabletLogos.length) === 0 ? desktopLogos : tabletLogos;
    mobileLogos = (mobileLogos === null || mobileLogos === void 0 ? void 0 : mobileLogos.length) === 0 ? desktopLogos : mobileLogos; // @ts-ignore
    const mobileLogosLength = mobileLogos.length; // @ts-ignore
    const tabletLogosLength = tabletLogos.length;
    const desktopLogosLength = desktopLogos.length;
    mobileLogos = [
        // @ts-ignore
        ...mobileLogos,
        ...mobileLogos,
        ...mobileLogos,
        ...mobileLogos
    ];
    tabletLogos = [
        ...tabletLogos,
        ...tabletLogos,
        ...tabletLogos,
        ...tabletLogos
    ];
    desktopLogos = [
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos
    ];
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _2lx21bp4 _zulputpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $haYnf.UniformColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1bsb1osq _1e0c1txw _1bahh9n0"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                        onClick: ()=>setRunning((r)=>!r),
                        className: (0, $esG4f.default)([
                            "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3 _1tjq11ib"
                            ]),
                            style: {
                                "--_qeag6c": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark400")),
                                "--_138lqrp": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark500")),
                                "--_44ufl2": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1000"))
                            },
                            children: running ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                                label: intl.formatMessage({
                                    id: "connector-logo-marquee.pause",
                                    defaultMessage: "Pause"
                                })
                            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                                label: intl.formatMessage({
                                    id: "connector-logo-marquee.play",
                                    defaultMessage: "Play"
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1bsb1osq _p12f1s5k _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1reo15vq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _o5721q9c",
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                            "_y44vc8cz _1y0c4ukn",
                            "_16uvtrqk",
                            "_181nglyw"
                        ]),
                        style: {
                            "--_1ikxs8u": (0, $43MIc.default)(running ? "running" : "paused")
                        },
                        children: mobileLogos.map((logo, index)=>{
                            const isOriginal = index < mobileLogosLength;
                            return /*#__PURE__*/ (0, $loA2J.jsx)($b383584eb4fcfdf4$var$Logo, (0, $7Knp0._)({
                                ariaHidden: !isOriginal,
                                tabIndex: isOriginal ? 0 : -1
                            }, logo), index);
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _o5721q9c",
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                            "_y44v7abo _1y0c4ukn",
                            "_16uvtrqk",
                            "_dm25glyw _sugaglyw"
                        ]),
                        style: {
                            "--_1ikxs8u": (0, $43MIc.default)(running ? "running" : "paused")
                        },
                        children: tabletLogos.map((logo, index)=>{
                            const isOriginal = index < tabletLogosLength;
                            return /*#__PURE__*/ (0, $loA2J.jsx)($b383584eb4fcfdf4$var$Logo, (0, $7Knp0._)({
                                ariaHidden: !isOriginal,
                                tabIndex: isOriginal ? 0 : -1
                            }, logo), index);
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _o5721q9c",
                            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                            "_y44vhu9l _1y0c4ukn",
                            "_16uvtrqk",
                            "_1mjbglyw"
                        ]),
                        style: {
                            "--_1ikxs8u": (0, $43MIc.default)(running ? "running" : "paused")
                        },
                        children: desktopLogos.map((logo, index)=>{
                            const isOriginal = index < desktopLogosLength;
                            return /*#__PURE__*/ (0, $loA2J.jsx)($b383584eb4fcfdf4$var$Logo, (0, $7Knp0._)({
                                ariaHidden: !isOriginal,
                                tabIndex: isOriginal ? 0 : -1
                            }, logo), index);
                        })
                    })
                ]
            })
        ]
    });
};
const $b383584eb4fcfdf4$var$linkCss = null;
const $b383584eb4fcfdf4$var$logoCss = null;
const $b383584eb4fcfdf4$var$listCss = null;
const $b383584eb4fcfdf4$var$marqueeContainerCss = null;
const $b383584eb4fcfdf4$var$marqueeButtonContainerCss = null;
const $b383584eb4fcfdf4$var$marqueeButtonCss = null;
const $b383584eb4fcfdf4$var$buttonCirlceCss = null;
const $b383584eb4fcfdf4$var$listContainerCss = null;
const $b383584eb4fcfdf4$var$animationKeyframesCss = null;
const $b383584eb4fcfdf4$var$pauseOnHoverCss = null;
const $b383584eb4fcfdf4$var$desktopCss = null;
const $b383584eb4fcfdf4$var$tabletCss = null;
const $b383584eb4fcfdf4$var$mobileCss = null;

});



parcelRegister("3MlHp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1a586d8aa0b7967$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $aiugz = parcelRequire("aiugz");

var $lK5pR = parcelRequire("lK5pR");

var $8lB1y = parcelRequire("8lB1y");
const $a1a586d8aa0b7967$var$UniformExpand = (props)=>{
    var _props_eventDataName, _props_expandedLabelText;
    const expandProps = {
        eventDataName: (_props_eventDataName = props.eventDataName) !== null && _props_eventDataName !== void 0 ? _props_eventDataName : undefined,
        chevronColor: props.chevronColor,
        boldLabel: props.richText ? false : props.boldLabel,
        label: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.richText
        }) : props.label,
        expandedLabelText: (_props_expandedLabelText = props.expandedLabelText) !== null && _props_expandedLabelText !== void 0 ? _props_expandedLabelText : null
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lK5pR.Expand), (0, $6iHNw._)((0, $7Knp0._)({}, expandProps), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aiugz.UniformSlot), {
            name: "contents"
        })
    }));
};
var $a1a586d8aa0b7967$export$2e2bcd8739ae039 = $a1a586d8aa0b7967$var$UniformExpand;

});

parcelRegister("lwXlz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("bVuUk")).default; });

var $bVuUk = parcelRequire("bVuUk");

});
parcelRegister("bVuUk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5257a26eb9cdb4bd$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dMM9X = parcelRequire("dMM9X");

var $8lB1y = parcelRequire("8lB1y");
const $5257a26eb9cdb4bd$var$UniformFeaturesHighlight = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dMM9X.FeaturesHighlight), {
        title: props.title,
        description: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.richText
        }) : props.description,
        linkText: props.linkText,
        linkHref: props.linkHref,
        feature1Eyebrow: props.feature1Eyebrow,
        feature1Title: props.feature1Title,
        feature1Body: props.feature1RichText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.feature1RichText
        }) : props.feature1Body,
        feature1ImageSrc: props.feature1ImageSrc,
        feature1ImageAltText: props.feature1ImageAltText,
        feature2Eyebrow: props.feature2Eyebrow,
        feature2Title: props.feature2Title,
        feature2Body: props.feature2RichText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.feature2RichText
        }) : props.feature2Body,
        feature2ImageSrc: props.feature2ImageSrc,
        feature2ImageAltText: props.feature2ImageAltText,
        feature3Eyebrow: props.feature3Eyebrow,
        feature3Title: props.feature3Title,
        feature3Body: props.feature3RichText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.feature3RichText
        }) : props.feature3Body,
        feature3ImageSrc: props.feature3ImageSrc,
        feature3ImageAltText: props.feature3ImageAltText
    });
};
var $5257a26eb9cdb4bd$export$2e2bcd8739ae039 = $5257a26eb9cdb4bd$var$UniformFeaturesHighlight;

});


parcelRegister("c81IA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("2wBma")).default; });

var $2wBma = parcelRequire("2wBma");

});
parcelRegister("2wBma", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be18c9833cb00a29$export$2e2bcd8739ae039; });
/* image-v2.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");
// eslint-disable-next-line complexity
const $be18c9833cb00a29$var$UniformImageV2 = ({ source: source, altText: altText = "", width: width, maxWidth: maxWidth, height: height, maxHeight: maxHeight, objectFit: objectFit, objectPosition: objectPosition, tabletWidth: tabletWidth, desktopWidth: desktopWidth, tabletHeight: tabletHeight, desktopHeight: desktopHeight, makeCircle: makeCircle = false })=>{
    const imageStyle = {
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    const widthStyle = null;
    const heightStyle = null;
    const tabletWidthStyle = null;
    const desktopWidthStyle = null;
    const tabletHeightStyle = null;
    const desktopHeightStyle = null; // @ts-ignore
    const responsiveStyles = null;
    const makeCircleStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
        src: source,
        alt: altText,
        className: (0, $esG4f.default)([
            width && "_1bsbzdsf",
            height && "_4t3i1rot",
            tabletWidth && "_14b51mzn",
            desktopWidth && "_glte1k6c",
            tabletHeight && "_1xloa7f3",
            desktopHeight && "_165tbekw",
            makeCircle && "_2rko1ssb"
        ]),
        style: (0, $6iHNw._)((0, $7Knp0._)({}, imageStyle), {
            "--_m5r7t4": (0, $43MIc.default)(width ? width : "auto"),
            "--_mzs5ed": (0, $43MIc.default)(height ? height : "auto"),
            "--_dwkr3u": (0, $43MIc.default)(tabletWidth ? tabletWidth : "auto"),
            "--_1mc860w": (0, $43MIc.default)(desktopWidth ? desktopWidth : "auto"),
            "--_1cta8t7": (0, $43MIc.default)(tabletHeight ? tabletHeight : "auto"),
            "--_1frmj6s": (0, $43MIc.default)(desktopHeight ? desktopHeight : "auto")
        })
    });
};
var $be18c9833cb00a29$export$2e2bcd8739ae039 = $be18c9833cb00a29$var$UniformImageV2;

});


parcelRegister("db1CJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("jnZNE")).default; });

var $jnZNE = parcelRequire("jnZNE");

});
parcelRegister("jnZNE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea9189acc3063704$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $kMNUa = parcelRequire("kMNUa");

var $dMM9X = parcelRequire("dMM9X");

var $8lB1y = parcelRequire("8lB1y");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ea9189acc3063704$var$UniformIntegration = (props)=>{
    const { eyebrow: eyebrow, title: title, titleAs: titleAs, body: body, richText: richText, linkLabel: linkLabel, linkHref: linkHref, logos: logos, background: background, backgroundColor: backgroundColor, flipLayout: flipLayout } = (0, $kMNUa.flattenLogoProps)(props);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dMM9X.Integration), {
        eyebrow: eyebrow,
        title: title,
        titleAs: titleAs,
        body: richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: richText
        }) : body,
        linkLabel: linkLabel,
        linkHref: linkHref,
        logos: logos,
        background: background,
        backgroundColor: backgroundColor,
        flipLayout: flipLayout
    });
};
var $ea9189acc3063704$export$2e2bcd8739ae039 = $ea9189acc3063704$var$UniformIntegration;

});
parcelRegister("kMNUa", function(module, exports) {

$parcel$export(module.exports, "flattenLogoProps", function () { return $2de6a15df111b993$export$ffc5469ebe0e6998; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $2bAHw = parcelRequire("2bAHw");
const $2de6a15df111b993$export$ffc5469ebe0e6998 = (props)=>{
    return (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        logos: (0, $2bAHw.flattenValues)(props.logos)
    });
};

});



parcelRegister("8X3P4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("gnm3L")).default; });

var $gnm3L = parcelRequire("gnm3L");

});
parcelRegister("gnm3L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82eae7017722f440$export$2e2bcd8739ae039; });
/* invisible-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $82eae7017722f440$var$UniformInvisibleContent = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-content": props.content,
        className: (0, $esG4f.default)([
            "_1e0cglyw"
        ])
    });
};
var $82eae7017722f440$export$2e2bcd8739ae039 = $82eae7017722f440$var$UniformInvisibleContent;

});


parcelRegister("cmgz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("y6XPA")).default; });

var $y6XPA = parcelRequire("y6XPA");

});
parcelRegister("y6XPA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c33207fb5f4a10c$export$2e2bcd8739ae039; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dMM9X = parcelRequire("dMM9X");

var $kMNUa = parcelRequire("kMNUa");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0c33207fb5f4a10c$var$UniformLogos = (intakeProps)=>{
    const { title: title, logos: logos } = (0, $kMNUa.flattenLogoProps)(intakeProps);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpoahv _pdlmxncg _y3gn1h6o"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dMM9X.Logos), {
                logos: logos
            })
        ]
    });
};
var $0c33207fb5f4a10c$export$2e2bcd8739ae039 = $0c33207fb5f4a10c$var$UniformLogos;

});


parcelRegister("kh16D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3HmCN")).default; });

var $3HmCN = parcelRequire("3HmCN");

});
parcelRegister("3HmCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85cb8a5f1dff2eeb$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $dMM9X = parcelRequire("dMM9X");

var $8lB1y = parcelRequire("8lB1y");
const $85cb8a5f1dff2eeb$var$UniformMobileApp = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dMM9X.MobileApp), {
        title: props.title,
        description: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lB1y.RichTextComponent), {
            text: props.richText
        }) : props.description,
        linkLabel: props.linkLabel,
        linkHref: props.linkHref,
        imageSrc: props.imageSrc,
        imageAlt: props.imageAlt,
        appleAppStoreUrl: props.appleAppStoreUrl,
        googlePlayStoreUrl: props.googlePlayStoreUrl
    });
};
var $85cb8a5f1dff2eeb$export$2e2bcd8739ae039 = $85cb8a5f1dff2eeb$var$UniformMobileApp;

});


parcelRegister("4DwX2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("a35tB")).default; });

var $a35tB = parcelRequire("a35tB");

});
parcelRegister("a35tB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3794429f5920107$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $7eZEV = parcelRequire("7eZEV");

var $krNyQ = parcelRequire("krNyQ");
const $d3794429f5920107$var$UniformPanel = (props)=>{
    var _props_description;
    const panelProps = {
        panelType: props.panelType,
        label: props.label,
        description: props.richText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
            name: null,
            text: props.richText
        }) : (_props_description = props.description) !== null && _props_description !== void 0 ? _props_description : null
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eZEV.Panel), (0, $7Knp0._)({}, panelProps));
};
var $d3794429f5920107$export$2e2bcd8739ae039 = $d3794429f5920107$var$UniformPanel;

});


parcelRegister("gcnH1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("4d1KE")).default; });

var $4d1KE = parcelRequire("4d1KE");

});
parcelRegister("4d1KE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c51c6f21ea637a9d$export$2e2bcd8739ae039; });
/* rovo-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $2bAHw = parcelRequire("2bAHw");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $haYnf = parcelRequire("haYnf");
const $c51c6f21ea637a9d$var$UniformRovoHero = ({ defaultHeading: defaultHeading, defaultSubheading: defaultSubheading, videoCarousel: videoCarousel, primaryCtaLabel: primaryCtaLabel, primaryCtaHref: primaryCtaHref, flattenData: flattenData = true })=>{
    const videoCarouselData = flattenData ? (0, $2bAHw.flattenValues)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    videoCarousel) : videoCarousel;
    const videoRefs = (0, $iSvIT.useRef)([]);
    const videoContainerRef = (0, $iSvIT.useRef)(null);
    const [current, setCurrent] = (0, $iSvIT.useState)(-1);
    const currentRef = (0, $iSvIT.useRef)(current);
    const [playing, setPlaying] = (0, $iSvIT.useState)(true);
    const [durations, setDurations] = (0, $iSvIT.useState)(Array(videoCarouselData.length).fill(0));
    const [fillBarResetKey, setFillBarResetKey] = (0, $iSvIT.useState)(0); // @ts-ignore
    const prevViewportWidth = (0, $iSvIT.useRef)(typeof window !== "undefined" ? window.innerWidth : 0);
    const [viewportWidth, setViewportWidth] = (0, $iSvIT.useState)(typeof window !== "undefined" ? window.innerWidth : 0);
    (0, $iSvIT.useEffect)(()=>{
        currentRef.current = current;
    }, [
        current
    ]); // On-load
    (0, $iSvIT.useEffect)(()=>{
        let hasRun = false;
        let observer = null;
        let wheelTimeout = null;
        let keyTimeout = null;
        function runEffectLogic() {
            if (hasRun) return;
            hasRun = true;
            const handleFirstInteraction = ()=>{
                if (currentRef.current === -1) setCurrent(0);
            };
            const handleFirstClick = ()=>{
                handleFirstInteraction();
                enableScrollEvents();
            }; // Scroll blocking
            function preventDefault(e) {
                e.preventDefault();
                handleFirstInteraction();
            }
            function onWheel(e) {
                preventDefault(e);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                wheelTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onKeyDown(e) {
                preventDefault(e);
                if (keyTimeout) clearTimeout(keyTimeout);
                keyTimeout = setTimeout(enableScrollEvents, 20);
            }
            function onTouchMove(e) {
                preventDefault(e);
            }
            function onTouchEnd() {
                enableScrollEvents();
            }
            function blockScrollEvents() {
                window.addEventListener("wheel", onWheel, {
                    passive: false
                });
                window.addEventListener("touchmove", onTouchMove, {
                    passive: false
                });
                window.addEventListener("touchend", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("touchcancel", onTouchEnd, {
                    passive: false
                });
                window.addEventListener("keydown", onKeyDown, {
                    passive: false
                });
            }
            function enableScrollEvents() {
                window.removeEventListener("wheel", onWheel);
                window.removeEventListener("touchmove", onTouchMove);
                window.removeEventListener("touchend", onTouchEnd);
                window.removeEventListener("touchcancel", onTouchEnd);
                window.removeEventListener("keydown", onKeyDown);
                if (wheelTimeout) clearTimeout(wheelTimeout);
                if (keyTimeout) clearTimeout(keyTimeout);
            }
            blockScrollEvents(); // Video container click interactions
            const container = videoContainerRef.current;
            if (container) container.addEventListener("pointerdown", handleFirstClick, {
                once: true
            });
             // Video durations
            videoCarouselData.forEach((_, idx)=>{
                const video = videoRefs.current[idx];
                if (!video) return;
                if (video.readyState >= 1) setDurations((durs)=>{
                    const copy = [
                        ...durs
                    ];
                    copy[idx] = video.duration;
                    return copy;
                });
                else video.onloadedmetadata = ()=>{
                    setDurations((durs)=>{
                        const copy = [
                            ...durs
                        ];
                        copy[idx] = video.duration;
                        return copy;
                    });
                };
            }); // Cleanup
            return ()=>{
                enableScrollEvents();
                if (container) {
                    container.removeEventListener("pointerdown", handleFirstInteraction);
                    container.removeEventListener("keydown", handleFirstInteraction);
                }
            };
        }
        // Intersection Observer setup
        observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry && entry.isIntersecting) {
                runEffectLogic();
                observer === null || observer === void 0 ? void 0 : observer.disconnect();
            }
        }, {
            threshold: 0.1
        });
        if (videoContainerRef.current) observer.observe(videoContainerRef.current);
         // Cleanup
        return ()=>{
            if (observer && videoContainerRef.current) observer.unobserve(videoContainerRef.current);
        };
    }, []);
    // Play next video on end, looping
    const handleEnded = ()=>{
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent((prev)=>(prev + 1) % videoCarouselData.length);
    }; // Pause/play current video
    (0, $iSvIT.useEffect)(()=>{
        if (current === -1) return;
        const video = videoRefs.current[current];
        if (video) {
            if (playing) {
                if (video.ended) video.currentTime = 0;
                 // eslint-disable-next-line @typescript-eslint/no-empty-function
                video.play().catch(()=>{});
            } else video.pause();
        }
    }, [
        playing,
        current
    ]); // Pause/play toggle
    const togglePlay = ()=>{
        setPlaying((p)=>!p);
    }; // Jump to a specific video and start from beginning
    const handleTeamClick = (idx)=>{
        if (idx === current) return;
        const currVideo = videoRefs.current[current];
        if (currVideo) {
            currVideo.pause();
            currVideo.currentTime = 0;
        }
        setCurrent(idx);
        setPlaying(true);
    };
    const currentDuration = durations[current] || 10; // Responsive asset type
    (0, $iSvIT.useEffect)(()=>{
        let resizeTimeout;
        const breakpoints = [
            768,
            1024
        ]; // Store previous width outside the handler so it persists
        const prevViewportWidth = {
            current: window.innerWidth
        };
        function crossedBreakpoint(prev, curr) {
            return breakpoints.some((bp)=>prev < bp && curr >= bp || prev >= bp && curr < bp);
        }
        const handleResizeEnd = ()=>{
            const currWidth = window.innerWidth;
            if (crossedBreakpoint(prevViewportWidth.current, currWidth)) setFillBarResetKey((k)=>k + 1);
            prevViewportWidth.current = currWidth;
        };
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(handleResizeEnd, 300);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
            if (resizeTimeout !== undefined) clearTimeout(resizeTimeout);
        };
    }, []);
    const assetType = viewportWidth >= 1024 ? "desktop" : viewportWidth >= 768 ? "tablet" : "mobile";
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _kqswh2mm _bfhk1rga"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _1e023bav _3zmjv4q2",
                    "_t9ec1qbm"
                ]),
                style: {
                    "--_12q5zt9": (0, $43MIc.default)(current !== -1 ? "translateX(-120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ih4h04rnm06355wnp2arca3f4gkg0258.webp",
                    alt: "",
                    style: $c51c6f21ea637a9d$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1mjbglyw",
                    "_v5641pp7 _kqswstnw _1pbykb7n _rjxp3bav _1fbdv4q2",
                    "_t9ecc5kj"
                ]),
                style: {
                    "--_1ylu95p": (0, $43MIc.default)(current !== -1 ? "translateX(120px)" : "translateX(0)")
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3qji3u3j76e5i63yjsj7pnko2npm30n4.webp",
                    alt: "",
                    style: $c51c6f21ea637a9d$var$desktopAssetStyle
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1reo15vq _1rjcxncg _133i1ejb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $haYnf.UniformColumnLayout), {
                        layout: "8",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o"
                            ]),
                            children: [
                                defaultSubheading && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_16mf1pz4 _12n91k8s _179m1k92 _1k84oxwj",
                                        "body-lg subheading"
                                    ]),
                                    style: {
                                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                                    },
                                    children: defaultSubheading
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_4cvr1h6o _1pfhpxbi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                        className: (0, $esG4f.default)([
                                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _a13e10xh"
                                        ]),
                                        children: defaultHeading
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _1n261g80 _zulputpp _1bah1h6o _1mou1ejb _urukpxbi"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Button), {
                                        href: primaryCtaHref,
                                        className: (0, $esG4f.default)([
                                            "_3fcw1q9c _1cqs1j6v _1bys1k92 _1jw8bfng"
                                        ]),
                                        children: primaryCtaLabel
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        ref: videoContainerRef,
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _1e021ssb _t9eczr6s",
                            "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1bsb1osq _4t3i1osq _1e0c1ule _y3gn1h6o _kqswh2mm _1reo15vq _18m915vq"
                            ]),
                            children: videoCarouselData.map(({ team: team, mobileVideoSrc: mobileVideoSrc, tabletVideoSrc: tabletVideoSrc, desktopVideoSrc: desktopVideoSrc, mobilePoster: mobilePoster, tabletPoster: tabletPoster, desktopPoster: desktopPoster, ariaLabel: ariaLabel }, idx)=>/*#__PURE__*/ {
                                var _ref;
                                return (0, $loA2J.jsx)("video", {
                                    ref: (el)=>videoRefs.current[idx] = el,
                                    src: assetType === "desktop" ? desktopVideoSrc : assetType === "tablet" ? tabletVideoSrc : mobileVideoSrc,
                                    muted: true,
                                    playsInline: true,
                                    onEnded: handleEnded,
                                    autoPlay: idx === current && playing,
                                    controls: false,
                                    "aria-label": ariaLabel,
                                    preload: "auto",
                                    poster: (_ref = assetType === "desktop" ? desktopPoster : assetType === "tablet" ? tabletPoster : mobilePoster) !== null && _ref !== void 0 ? _ref : undefined,
                                    className: (0, $esG4f.default)([
                                        "_1bsb17gh _4t3ieo28 _12rr13bv _1vkh124j _1rfmixjv _tnru1jje",
                                        "_3um01ppy _4t3io5ou"
                                    ]),
                                    style: {
                                        "--_1wpk543": (0, $43MIc.default)(idx === current || idx === 0 && current === -1 ? "visible" : "hidden"),
                                        "--_1b1vnti": (0, $43MIc.default)(idx === current || idx === 0 && current === -1 ? "100%" : 0)
                                    }
                                }, team);
                            })
                        })
                    }),
                    current !== -1 && /*#__PURE__*/ (0, $loA2J.jsx)((0, $haYnf.UniformColumnLayout), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1pfhoahv _195g1wug _1bsb1osq _p12fbxu3 _zulputpp _y44v1dy3 _1e0c11p5 _yv0e1qft _476dutpp _19d71wug _zzszh9n0"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                    onClick: togglePlay,
                                    className: (0, $esG4f.default)([
                                        "_4t3i1ady _1bsb1ady _19pkyjp0 _2hwxyjp0 _otyryjp0 _18u0yjp0 _bfhk1j28 _19itglyw _2rko1osq _1ii7kb7n _yyhycs5v _d0altlke _1tzgkb7n _1acakb7n"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_4t3izwfg _1bsbzwfg _bfhk1aeo _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31s03 _1tjq1s1x"
                                        ]),
                                        style: {
                                            "--_44ufl2": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark1000")),
                                            "--_1mbq9ci": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark800")),
                                            "--_1jncskl": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark300"))
                                        },
                                        children: playing ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                                            label: intl.formatMessage({
                                                id: "rovo-hero.pause",
                                                defaultMessage: "Pause"
                                            })
                                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                                            label: intl.formatMessage({
                                                id: "rovo-hero.play",
                                                defaultMessage: "Play"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _4cvr1y6m _zulputpp _1bsb1osq"
                                    ]),
                                    children: videoCarouselData.map(({ team: team }, idx)=>/*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                                            onClick: ()=>handleTeamClick(idx),
                                            className: (0, $esG4f.default)([
                                                "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _ect41pz4 _1wyb1j6v _k48p1fw0 _vwz41k8s",
                                                "_syazxvv5 _d0al18ta"
                                            ]),
                                            style: {
                                                "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                                                "--_145xjfw": (0, $43MIc.default)(idx === current ? (0, $5ohHq.wacToken)("color.primary.blue") : (0, $5ohHq.wacToken)("color.neutral.light800")),
                                                "--_1sd2kd4": (0, $43MIc.default)(idx === current ? "auto" : "pointer")
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    className: (0, $esG4f.default)([
                                                        "_4t3iftgi _1bsb1osq _kqswh2mm _1reo15vq _18m915vq _bfhku4vp _1mou1ilp",
                                                        idx === 0 && "_2rkonggr",
                                                        idx === videoCarouselData.length - 1 && "_2rkof82g"
                                                    ]),
                                                    style: {
                                                        "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                                                    },
                                                    children: idx === current && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                        className: (0, $esG4f.default)([
                                                            "_4t3i1osq _1bsb1osq _bfhk17la _kqswstnw _1e02idpf _152tidpf",
                                                            "_y44v1gj6 _1y0c1j4f",
                                                            "fillBar"
                                                        ]),
                                                        style: {
                                                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                                                            "--_1fmqpqp": (0, $43MIc.default)(currentDuration, "s"),
                                                            "--_snrfvu": (0, $43MIc.default)(playing ? "running" : "paused")
                                                        }
                                                    }, fillBarResetKey)
                                                }),
                                                team
                                            ]
                                        }, team))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_181nglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6ts3bd426400kq6ds07w1208q7a038r0.webp",
                    alt: "",
                    style: $c51c6f21ea637a9d$var$imageStyles,
                    className: (0, $esG4f.default)([
                        "_181nglyw"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_dm25glyw _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/6325jfp76jcjym74os216mopusw7m420.webp",
                    alt: "",
                    style: $c51c6f21ea637a9d$var$imageStyles
                })
            })
        ]
    });
};
var $c51c6f21ea637a9d$export$2e2bcd8739ae039 = $c51c6f21ea637a9d$var$UniformRovoHero;
const $c51c6f21ea637a9d$var$desktopAssetStyle = {
    width: "787px"
};
const $c51c6f21ea637a9d$var$desktopLeftAssetCss = null;
const $c51c6f21ea637a9d$var$desktopRightAssetCss = null;
const $c51c6f21ea637a9d$var$desktopCss = null;
const $c51c6f21ea637a9d$var$tabletCss = null;
const $c51c6f21ea637a9d$var$mobileCss = null;
const $c51c6f21ea637a9d$var$imageStyles = {
    width: "100%",
    height: "100%",
    display: "block"
};
const $c51c6f21ea637a9d$var$sectionCss = null;
const $c51c6f21ea637a9d$var$containerCss = null;
const $c51c6f21ea637a9d$var$subheadingCss = null;
const $c51c6f21ea637a9d$var$headingContainerCss = null;
const $c51c6f21ea637a9d$var$headingCss = null;
const $c51c6f21ea637a9d$var$h1Css = null;
const $c51c6f21ea637a9d$var$ctaContainerCss = null;
const $c51c6f21ea637a9d$var$ctaCss = null;
const $c51c6f21ea637a9d$var$videoContainerCss = null;
const $c51c6f21ea637a9d$var$videoDimensionsCss = null;
const $c51c6f21ea637a9d$var$videoCss = null;
const $c51c6f21ea637a9d$var$fadeIn = null;
const $c51c6f21ea637a9d$var$controlContainerCss = null;
const $c51c6f21ea637a9d$var$barContainerCss = null;
const $c51c6f21ea637a9d$var$buttonCss = null;
const $c51c6f21ea637a9d$var$buttonCirlceCss = null;
const $c51c6f21ea637a9d$var$firstBarCss = null;
const $c51c6f21ea637a9d$var$lastBarCss = null;
const $c51c6f21ea637a9d$var$barbuttonCss = null;
const $c51c6f21ea637a9d$var$barCss = null;
const $c51c6f21ea637a9d$var$fillBarCss = null;
const $c51c6f21ea637a9d$var$fill = null;

});


parcelRegister("dj3LQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("1BNhI")).default; });

var $1BNhI = parcelRequire("1BNhI");

});
parcelRegister("1BNhI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe748f793dea70b$export$2e2bcd8739ae039; });
/* scrollable-cards.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $7d77Q = parcelRequire("7d77Q");

var $1UUq1 = parcelRequire("1UUq1");

var $5VMi0 = parcelRequire("5VMi0");

var $5ohHq = parcelRequire("5ohHq");
const $afe748f793dea70b$var$UniformScrollableHeroCards = (props)=>{
    const { flattenData: flattenData = true } = props;
    let { scrollableCard: scrollableCard } = props;
    if (flattenData) {
        const flattened = (0, $7d77Q.flattenScrollableCardProps)(props);
        scrollableCard = flattened.scrollableCard;
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_11q71ybm _1rjcpxbi _18zr1jfw _1bhl1ejb"
        ]),
        style: {
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1bsb1s9t _p12f1osq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _9nneu2gc _1yt4u2gc _zulp1ejb _85i51ejb _1reo1wug _rjfvx6dd _1fjgurpi _a5o91kbs _15peu2gc _1v6m1rga _gce7u2gc _aayn1q9v _155au2gc _1w1e15zi _2osnpxbi"
            ]),
            style: {
                "--_o8nmkh": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue500")),
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            },
            children: scrollableCard === null || scrollableCard === void 0 ? void 0 : scrollableCard.map((card, index)=>{
                var _card_scrollableCardUrl;
                const cardContent = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5VMi0.Lozenge), {
                            appearance: card.scrollableCardLozengeColor || "neutral",
                            text: card.scrollableCardLozengeText
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_18s86fpf _1yt414kv _th3simiu _lrmn10nf",
                                "scrollable-card-title"
                            ]),
                            children: card.scrollableCardTitle
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Image), {
                            src: card.scrollableCardImage,
                            alt: card.scrollableCardTitle
                        })
                    ]
                });
                return ((_card_scrollableCardUrl = card.scrollableCardUrl) === null || _card_scrollableCardUrl === void 0 ? void 0 : _card_scrollableCardUrl.path) ? /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                    href: card.scrollableCardUrl.path,
                    "aria-label": card.scrollableCardUrl.alt || card.scrollableCardTitle,
                    className: (0, $esG4f.default)([
                        "_1hu1v2br _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsbeq5r _1ul9eq5r _zulp1b66 _11q7cd5j _2rkovwyg _16qszucj _1yt418tt _mezj1osq _bna7sb0t _1jpx1dfr _1j3s1nty _1cr61wug _1hlxidpf _1874idpf _10ewidpf",
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazn7od _80omtlke _v564iooc _1llwjtcz _1dbz1cd0 _y2mv1mie"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                        "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                        "--_o8nmkh": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue500"))
                    },
                    children: cardContent
                }, index) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1hu1v2br _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4cvr1y6m _1bsbeq5r _1ul9eq5r _zulp1b66 _11q7cd5j _2rkovwyg _16qszucj _1yt418tt _mezj1osq _bna7sb0t _1jpx1dfr _1j3s1nty _1cr61wug _1hlxidpf _1874idpf _10ewidpf"
                    ]),
                    style: {
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                        "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card"))
                    },
                    children: cardContent
                }, index);
            })
        })
    });
};
const $afe748f793dea70b$var$containerStyles = null;
const $afe748f793dea70b$var$scrollableContainer = null;
const $afe748f793dea70b$var$titleStyles = null;
const $afe748f793dea70b$var$cardWrapper = null;
const $afe748f793dea70b$var$clickableCardStyles = null;
var $afe748f793dea70b$export$2e2bcd8739ae039 = $afe748f793dea70b$var$UniformScrollableHeroCards;

});
parcelRegister("7d77Q", function(module, exports) {

$parcel$export(module.exports, "flattenScrollableCardProps", function () { return $65ca9603bccee51b$export$f91448e13674e82b; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $2bAHw = parcelRequire("2bAHw");
const $65ca9603bccee51b$export$f91448e13674e82b = (props)=>{
    return (0, $6iHNw._)((0, $7Knp0._)({}, props), {
        scrollableCard: (0, $2bAHw.flattenValues)(props.scrollableCard)
    });
};

});



parcelRegister("borry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("impgo")).default; });

var $impgo = parcelRequire("impgo");

});
parcelRegister("impgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $579d7e0176dcd680$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $1UUq1 = parcelRequire("1UUq1");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $579d7e0176dcd680$var$transformNavItemData = (slots)=>{
    return slots.map((childComponent)=>{
        var _childProps_text, _childProps_href, _childProps_collectionName, _childComponent_slots;
        var _childComponent_parameters;
        const childProps = (_childComponent_parameters = childComponent.parameters) !== null && _childComponent_parameters !== void 0 ? _childComponent_parameters : {};
        if (childComponent.type === "sideNavLink") return {
            type: "link",
            text: (_childProps_text = childProps["text"]) === null || _childProps_text === void 0 ? void 0 : _childProps_text.value,
            href: (_childProps_href = childProps["href"]) === null || _childProps_href === void 0 ? void 0 : _childProps_href.value
        };
        if (childComponent.type === "sideNavCollection") return {
            type: "collection",
            collectionName: (_childProps_collectionName = childProps["collectionName"]) === null || _childProps_collectionName === void 0 ? void 0 : _childProps_collectionName.value,
            sideNavItems: $579d7e0176dcd680$var$transformNavItemData((_childComponent_slots = childComponent.slots) === null || _childComponent_slots === void 0 ? void 0 : _childComponent_slots["sideNavItems"])
        };
        return;
    });
};
const $579d7e0176dcd680$var$UniformSideNavCollection = ({ component: component })=>{
    var _component_slots, _component_parameters_collectionName, _component_parameters;
    var _component_slots_sideNavItems;
    const slotItems = (_component_slots_sideNavItems = (_component_slots = component.slots) === null || _component_slots === void 0 ? void 0 : _component_slots["sideNavItems"]) !== null && _component_slots_sideNavItems !== void 0 ? _component_slots_sideNavItems : null;
    if (!slotItems) return;
    const sideNavItems = $579d7e0176dcd680$var$transformNavItemData(slotItems);
    const props = {
        type: "collection",
        collectionName: (_component_parameters = component.parameters) === null || _component_parameters === void 0 ? void 0 : (_component_parameters_collectionName = _component_parameters["collectionName"]) === null || _component_parameters_collectionName === void 0 ? void 0 : _component_parameters_collectionName.value,
        sideNavItems: sideNavItems
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.SideNavCollection), (0, $7Knp0._)({}, props));
};
var $579d7e0176dcd680$export$2e2bcd8739ae039 = $579d7e0176dcd680$var$UniformSideNavCollection;

});


parcelRegister("5yXyq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("aogEX")).default; });

var $aogEX = parcelRequire("aogEX");

});
parcelRegister("aogEX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c268a96f0311a1f2$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $1UUq1 = parcelRequire("1UUq1");
const $c268a96f0311a1f2$var$UniformSideNavLink = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.SideNavLink), (0, $7Knp0._)({}, props));
};
var $c268a96f0311a1f2$export$2e2bcd8739ae039 = $c268a96f0311a1f2$var$UniformSideNavLink;

});


parcelRegister("enK00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("iDXPJ")).default; });

var $iDXPJ = parcelRequire("iDXPJ");

});
parcelRegister("iDXPJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f5fa523d60d66d8$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $axg8K = parcelRequire("axg8K");
const $0f5fa523d60d66d8$var$UniformSignUpForm = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $axg8K.default), {
        Login: null
    });
};
var $0f5fa523d60d66d8$export$2e2bcd8739ae039 = $0f5fa523d60d66d8$var$UniformSignUpForm;

});


parcelRegister("5wZPk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("k6qJQ")).default; });

var $k6qJQ = parcelRequire("k6qJQ");

});
parcelRegister("k6qJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1d8ed81ddc31042$export$2e2bcd8739ae039; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iWo90 = parcelRequire("iWo90");
const $d1d8ed81ddc31042$var$UniformTemplateCta = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iWo90.TemplateCta), (0, $7Knp0._)({}, props));
};
var $d1d8ed81ddc31042$export$2e2bcd8739ae039 = $d1d8ed81ddc31042$var$UniformTemplateCta;

});


parcelRegister("lOAhp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce01dca626f76d5f$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $hZiVF = parcelRequire("hZiVF");
const $ce01dca626f76d5f$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        title: null,
        details: null,
        asset: null,
        embedLink: null
    };
    const { topicintroduction: topicintroduction } = body;
    function getRichText(richText) {
        if (typeof richText === "string") return richText;
        return (0, $h2e6B.documentToHtmlString)(richText);
    }
    var _topicintroduction_topicIntroductionTitleExternal, _getRichText, _topicintroduction_embedLink;
    const formattedBody = {
        title: (_topicintroduction_topicIntroductionTitleExternal = topicintroduction === null || topicintroduction === void 0 ? void 0 : topicintroduction.topicIntroductionTitleExternal) !== null && _topicintroduction_topicIntroductionTitleExternal !== void 0 ? _topicintroduction_topicIntroductionTitleExternal : null,
        details: (_getRichText = getRichText(topicintroduction === null || topicintroduction === void 0 ? void 0 : topicintroduction.topicIntroductionDetails)) !== null && _getRichText !== void 0 ? _getRichText : null,
        asset: (()=>{
            var _topicintroduction_topicIntroductionAsset;
            const formattedAsset = $ce01dca626f76d5f$var$formatAsset(topicintroduction === null || topicintroduction === void 0 ? void 0 : (_topicintroduction_topicIntroductionAsset = topicintroduction.topicIntroductionAsset) === null || _topicintroduction_topicIntroductionAsset === void 0 ? void 0 : _topicintroduction_topicIntroductionAsset[0]);
            return formattedAsset ? [
                formattedAsset
            ] : null;
        })(),
        embedLink: (_topicintroduction_embedLink = topicintroduction === null || topicintroduction === void 0 ? void 0 : topicintroduction.embedLink) !== null && _topicintroduction_embedLink !== void 0 ? _topicintroduction_embedLink : null
    };
    return formattedBody;
};
// eslint-disable-next-line complexity
const $ce01dca626f76d5f$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $ce01dca626f76d5f$var$UniformTopicIntroductionContent = (props)=>{
    const topicIntroduction = (0, $iSvIT.useMemo)(()=>$ce01dca626f76d5f$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hZiVF.TopicIntroductionContent), {
        topicIntroduction: topicIntroduction
    });
};
var $ce01dca626f76d5f$export$2e2bcd8739ae039 = $ce01dca626f76d5f$var$UniformTopicIntroductionContent;

});
parcelRegister("hZiVF", function(module, exports) {

$parcel$export(module.exports, "TopicIntroductionContent", function () { return $ec014be53000938a$export$c79bf2a9fdb4b5c2; });
/* topic-introduction-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $krNyQ = parcelRequire("krNyQ");
function $ec014be53000938a$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
}
const $ec014be53000938a$export$c79bf2a9fdb4b5c2 = ({ topicIntroduction: topicIntroduction })=>{
    var _topicIntroduction_asset;
    var _topicIntroduction_title, _topicIntroduction_details, _topicIntroduction_embedLink, _topicIntroduction_title1, _topicIntroduction_asset_;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-hub-introduction-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            (topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title) && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthze3t"
                ]),
                children: topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title
            }),
            (topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.details) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthv47k"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    name: (_topicIntroduction_title = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title) !== null && _topicIntroduction_title !== void 0 ? _topicIntroduction_title : "",
                    text: $ec014be53000938a$var$getRichText((_topicIntroduction_details = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.details) !== null && _topicIntroduction_details !== void 0 ? _topicIntroduction_details : "")
                })
            }),
            (topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.embedLink) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                embedLink: (_topicIntroduction_embedLink = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.embedLink) !== null && _topicIntroduction_embedLink !== void 0 ? _topicIntroduction_embedLink : "",
                title: (_topicIntroduction_title1 = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : topicIntroduction.title) !== null && _topicIntroduction_title1 !== void 0 ? _topicIntroduction_title1 : "",
                thumbnail: (_topicIntroduction_asset_ = topicIntroduction === null || topicIntroduction === void 0 ? void 0 : (_topicIntroduction_asset = topicIntroduction.asset) === null || _topicIntroduction_asset === void 0 ? void 0 : _topicIntroduction_asset[0]) !== null && _topicIntroduction_asset_ !== void 0 ? _topicIntroduction_asset_ : null
            })
        ]
    });
};

});


parcelRegister("aDVDR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b437973572e74d97$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $h2e6B = parcelRequire("h2e6B");

var $kEwPg = parcelRequire("kEwPg");
const $b437973572e74d97$export$d9468344d3651243 = (body)=>{
    if (!body) return {
        tutorialIntroductionName: null,
        tutorialIntroductionDetails: null,
        tutorialIntroductionAsset: null,
        embedLink: null
    };
    const { tutorialintroduction: tutorialintroduction } = body;
    function getRichText(richText) {
        if (typeof richText === "string") return richText;
        return (0, $h2e6B.documentToHtmlString)(richText);
    }
    var _tutorialintroduction_tutorialIntroductionTitleExternal, _getRichText, _formatAsset, _tutorialintroduction_embedLink;
    const formattedBody = {
        tutorialIntroductionName: (_tutorialintroduction_tutorialIntroductionTitleExternal = tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.tutorialIntroductionTitleExternal) !== null && _tutorialintroduction_tutorialIntroductionTitleExternal !== void 0 ? _tutorialintroduction_tutorialIntroductionTitleExternal : null,
        tutorialIntroductionDetails: (_getRichText = getRichText(tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.tutorialIntroductionDetails)) !== null && _getRichText !== void 0 ? _getRichText : null,
        tutorialIntroductionAsset: (_formatAsset = $b437973572e74d97$var$formatAsset(tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.tutorialIntroductionAsset)) !== null && _formatAsset !== void 0 ? _formatAsset : null,
        embedLink: (_tutorialintroduction_embedLink = tutorialintroduction === null || tutorialintroduction === void 0 ? void 0 : tutorialintroduction.embedLink) !== null && _tutorialintroduction_embedLink !== void 0 ? _tutorialintroduction_embedLink : null
    };
    return formattedBody;
};
// eslint-disable-next-line complexity
const $b437973572e74d97$var$formatAsset = (asset)=>{
    var _fields_file_details, _fields_file, _fields_file1, _fields_file_image, _fields_file2, _fields_image, _fields_file3, _fields_file4;
    if (!(asset === null || asset === void 0 ? void 0 : asset.fields)) return undefined;
    const { fields: fields } = asset;
    var _fields_file_fileName, _fields_file_image_height, _fields_image_width, _fields_description, _fields_file_contentType;
    return {
        name: fields.title,
        size: (_fields_file = fields.file) === null || _fields_file === void 0 ? void 0 : (_fields_file_details = _fields_file.details) === null || _fields_file_details === void 0 ? void 0 : _fields_file_details.size,
        fileName: (_fields_file_fileName = (_fields_file1 = fields.file) === null || _fields_file1 === void 0 ? void 0 : _fields_file1.fileName) !== null && _fields_file_fileName !== void 0 ? _fields_file_fileName : null,
        height: (_fields_file_image_height = (_fields_file2 = fields.file) === null || _fields_file2 === void 0 ? void 0 : (_fields_file_image = _fields_file2.image) === null || _fields_file_image === void 0 ? void 0 : _fields_file_image.height) !== null && _fields_file_image_height !== void 0 ? _fields_file_image_height : null,
        width: (_fields_image_width = (_fields_image = fields.image) === null || _fields_image === void 0 ? void 0 : _fields_image.width) !== null && _fields_image_width !== void 0 ? _fields_image_width : null,
        url: (_fields_file3 = fields.file) === null || _fields_file3 === void 0 ? void 0 : _fields_file3.url,
        description: (_fields_description = fields.description) !== null && _fields_description !== void 0 ? _fields_description : null,
        contentType: (_fields_file_contentType = (_fields_file4 = fields.file) === null || _fields_file4 === void 0 ? void 0 : _fields_file4.contentType) !== null && _fields_file_contentType !== void 0 ? _fields_file_contentType : null
    };
};
const $b437973572e74d97$var$UniformTutorialIntroductionContent = (props)=>{
    const tutorialIntroduction = (0, $iSvIT.useMemo)(()=>$b437973572e74d97$export$d9468344d3651243(props), [
        props
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kEwPg.TutorialIntroductionContent), {
        tutorialIntroduction: tutorialIntroduction
    });
};
var $b437973572e74d97$export$2e2bcd8739ae039 = $b437973572e74d97$var$UniformTutorialIntroductionContent;

});
parcelRegister("kEwPg", function(module, exports) {

$parcel$export(module.exports, "TutorialIntroductionContent", function () { return $4bcc864d3cf1b6b7$export$8d53a13d50897e0d; });
/* tutorial-introduction-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $h2e6B = parcelRequire("h2e6B");

var $6O6jV = parcelRequire("6O6jV");

var $krNyQ = parcelRequire("krNyQ");
function $4bcc864d3cf1b6b7$var$getRichText(richText) {
    if (typeof richText === "string") return richText;
    return (0, $h2e6B.documentToHtmlString)(richText);
}
const $4bcc864d3cf1b6b7$export$8d53a13d50897e0d = ({ tutorialIntroduction: tutorialIntroduction })=>{
    var _tutorialIntroduction_tutorialIntroductionName, _tutorialIntroduction_tutorialIntroductionDetails, _tutorialIntroduction_embedLink, _tutorialIntroduction_tutorialIntroductionName1;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "agile-hub-introduction-content",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpv47k"
        ]),
        children: [
            (tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName) && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_6rthze3t"
                ]),
                children: tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName
            }),
            (tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionDetails) && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthv47k"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    name: (_tutorialIntroduction_tutorialIntroductionName = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName) !== null && _tutorialIntroduction_tutorialIntroductionName !== void 0 ? _tutorialIntroduction_tutorialIntroductionName : "",
                    text: $4bcc864d3cf1b6b7$var$getRichText((_tutorialIntroduction_tutorialIntroductionDetails = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionDetails) !== null && _tutorialIntroduction_tutorialIntroductionDetails !== void 0 ? _tutorialIntroduction_tutorialIntroductionDetails : "")
                })
            }),
            (tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.embedLink) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                embedLink: (_tutorialIntroduction_embedLink = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.embedLink) !== null && _tutorialIntroduction_embedLink !== void 0 ? _tutorialIntroduction_embedLink : "",
                title: (_tutorialIntroduction_tutorialIntroductionName1 = tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionName) !== null && _tutorialIntroduction_tutorialIntroductionName1 !== void 0 ? _tutorialIntroduction_tutorialIntroductionName1 : "",
                thumbnail: tutorialIntroduction === null || tutorialIntroduction === void 0 ? void 0 : tutorialIntroduction.tutorialIntroductionAsset
            })
        ]
    });
};

});


parcelRegister("d6DCu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3gOU8")).default; });

var $3gOU8 = parcelRequire("3gOU8");

});
parcelRegister("3gOU8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fd90b3956d2a9be$export$2e2bcd8739ae039; });
/* video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $gF60T = parcelRequire("gF60T");

var $7ShLR = parcelRequire("7ShLR");

var $5ohHq = parcelRequire("5ohHq");
const $9fd90b3956d2a9be$var$UniformVideo = ({ src: src, alt: alt = "", poster: poster, desktopHeight: desktopHeight, tabletHeight: tabletHeight, mobileHeight: mobileHeight })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    const [isPlaying, setIsPlaying] = (0, $iSvIT.useState)(false);
    const [hasError, setHasError] = (0, $iSvIT.useState)(false); // Play from beginning when in viewport, pause when out
    (0, $iSvIT.useEffect)(()=>{
        const video = videoRef.current;
        if (!video) return;
        const observer = new IntersectionObserver(([entry])=>{
            if (entry && entry.isIntersecting && !hasError) {
                video.currentTime = 0; // Always start from beginning
                video.play().catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                });
            } else video.pause();
        }, {
            threshold: 0.5
        });
        observer.observe(video);
        return ()=>{
            observer.disconnect();
        };
    }, [
        hasError
    ]);
    const togglePlay = ()=>{
        if (videoRef.current && !hasError) {
            if (isPlaying) {
                videoRef.current.pause();
                setIsPlaying(false);
            } else videoRef.current.play().then(()=>{
                setIsPlaying(true);
            }).catch(()=>{
                // Ignore error likely due to autoplay restrictions or browser power saving
                setIsPlaying(false);
            });
        }
    };
    const heightCss = null;
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
                ref: videoRef,
                playsInline: true,
                muted: true,
                preload: "auto",
                poster: poster,
                "aria-label": alt,
                "aria-hidden": alt === "",
                onPlay: ()=>setIsPlaying(true),
                onPause: ()=>setIsPlaying(false),
                onEnded: ()=>setIsPlaying(false),
                onError: ()=>setHasError(true),
                onLoadStart: ()=>setHasError(false),
                className: (0, $esG4f.default)([
                    "_165tbekw _1vkha7f3 _tnruirba"
                ]),
                style: {
                    maxWidth: "100%",
                    "--_1frmj6s": (0, $43MIc.default)(desktopHeight ? desktopHeight : "auto"),
                    "--_1cta8t7": (0, $43MIc.default)(tabletHeight ? tabletHeight : "auto"),
                    "--_k89wwe": (0, $43MIc.default)(mobileHeight ? mobileHeight : "auto")
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                        src: src,
                        type: "video/mp4"
                    }),
                    "Video not supported."
                ]
            }),
            !hasError && /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                onClick: togglePlay,
                className: (0, $esG4f.default)([
                    "_kqswstnw _u7cou2gc _rjxpu2gc _1yt412x7 _4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_4t3izwfg _1bsbzwfg _bfhkxv17 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr3mmjq _1tjq121t"
                    ]),
                    style: {
                        "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400")),
                        "--_1ayut75": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light500")),
                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                    },
                    children: isPlaying ? /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gF60T))), {
                        label: intl.formatMessage({
                            id: "uniform-video.pause",
                            defaultMessage: "Pause"
                        })
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ShLR))), {
                        label: intl.formatMessage({
                            id: "uniform-video.play",
                            defaultMessage: "Play"
                        })
                    })
                })
            })
        ]
    });
};
const $9fd90b3956d2a9be$var$controlButtonCss = null;
const $9fd90b3956d2a9be$var$buttonCircleCss = null;
var $9fd90b3956d2a9be$export$2e2bcd8739ae039 = $9fd90b3956d2a9be$var$UniformVideo;

});





//# sourceMappingURL=index.f3f41369.js.map
